// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AdhocIdentityCheckDigitalData,
  AdhocIdentityCheckDigitalErrors,
  AdhocIdentityCheckDigitalResponses,
  AuthAcceptInviteExistingUserData,
  AuthAcceptInviteExistingUserErrors,
  AuthAcceptInviteExistingUserResponses,
  AuthAcceptInviteNewUserData,
  AuthAcceptInviteNewUserErrors,
  AuthAcceptInviteNewUserResponses,
  AuthCheckInviteData,
  AuthCheckInviteErrors,
  AuthCheckInviteResponses,
  AuthSignupData,
  AuthSignupErrors,
  AuthSignupResponses,
  CheckdAddressValidateData,
  CheckdAddressValidateErrors,
  CheckdAddressValidateResponses,
  CheckdAutoEftDashboardData,
  CheckdAutoEftDashboardErrors,
  CheckdAutoEftDashboardResponses,
  CheckdDashboardMetricsData,
  CheckdDashboardMetricsErrors,
  CheckdDashboardMetricsResponses,
  EftAutoPaymentListData,
  EftAutoPaymentListErrors,
  EftAutoPaymentListResponses,
  FileUploadIntentData,
  FileUploadIntentErrors,
  FileUploadIntentResponses,
  FileViewData,
  FileViewErrors,
  GetFeatureFlagsData,
  GetFeatureFlagsErrors,
  GetFeatureFlagsResponses,
  GetHealthData,
  GetHealthErrors,
  GetHealthResponses,
  GetLookupTableValuesData,
  GetLookupTableValuesErrors,
  GetLookupTableValuesResponses,
  GetSelfAppDataData,
  GetSelfAppDataErrors,
  GetSelfAppDataResponses,
  IduAuditListData,
  IduAuditListErrors,
  IduAuditListResponses,
  IduAutoEftMerchantWarriorCheckData,
  IduAutoEftMerchantWarriorCheckErrors,
  IduAutoEftMerchantWarriorCheckResponses,
  IduAutoEftMetricsData,
  IduAutoEftMetricsErrors,
  IduAutoEftMetricsResponses,
  IduAutoEftRecordsData,
  IduAutoEftRecordsErrors,
  IduAutoEftRecordsResponses,
  IduAutoEftResolutionRecordData,
  IduAutoEftResolutionRecordErrors,
  IduAutoEftResolutionRecordResponses,
  IduAutoEftRetryableData,
  IduAutoEftRetryableErrors,
  IduAutoEftRetryableResponses,
  IduBndryAlertHistoryData,
  IduBndryAlertHistoryErrors,
  IduBndryAlertHistoryResponses,
  IduCheckdVenueSettingGetData,
  IduCheckdVenueSettingGetErrors,
  IduCheckdVenueSettingGetResponses,
  IduCheckdVenueSettingUpdateData,
  IduCheckdVenueSettingUpdateErrors,
  IduCheckdVenueSettingUpdateResponses,
  IduDashboardCheckdMetricsData,
  IduDashboardCheckdMetricsErrors,
  IduDashboardCheckdMetricsResponses,
  IduDashboardCheckdPayoutListData,
  IduDashboardCheckdPayoutListErrors,
  IduDashboardCheckdPayoutListResponses,
  IduDashboardCheckdVenueMetricsData,
  IduDashboardCheckdVenueMetricsErrors,
  IduDashboardCheckdVenueMetricsResponses,
  IduDashboardCheckdVenueTablesData,
  IduDashboardCheckdVenueTablesErrors,
  IduDashboardCheckdVenueTablesResponses,
  IduDashboardMetricsData,
  IduDashboardMetricsErrors,
  IduDashboardMetricsResponses,
  IduDashboardUserAddData,
  IduDashboardUserAddErrors,
  IduDashboardUserAddResponses,
  IduDashboardUsersListData,
  IduDashboardUsersListErrors,
  IduDashboardUsersListResponses,
  IduInAppMessageCreateData,
  IduInAppMessageCreateErrors,
  IduInAppMessageCreateResponses,
  IduInAppMessageDeleteData,
  IduInAppMessageDeleteErrors,
  IduInAppMessageDeleteResponses,
  IduInAppMessageGetData,
  IduInAppMessageGetErrors,
  IduInAppMessageGetResponses,
  IduInAppMessageListData,
  IduInAppMessageListErrors,
  IduInAppMessageListResponses,
  IduInAppMessageUpdateData,
  IduInAppMessageUpdateErrors,
  IduInAppMessageUpdateResponses,
  IduInviteAvailabilityData,
  IduInviteAvailabilityErrors,
  IduInviteAvailabilityResponses,
  IduInviteListData,
  IduInviteListErrors,
  IduInviteListResponses,
  IduInviteManualAcceptData,
  IduInviteManualAcceptErrors,
  IduInviteManualAcceptResponses,
  IduInviteResendData,
  IduInviteResendErrors,
  IduInviteResendResponses,
  IduInviteRevokeData,
  IduInviteRevokeErrors,
  IduInviteRevokeResponses,
  IduInviteSkipAndAddData,
  IduInviteSkipAndAddErrors,
  IduInviteSkipAndAddResponses,
  IduKycDashboardData,
  IduKycDashboardErrors,
  IduKycDashboardResponses,
  IduLogsListData,
  IduLogsListErrors,
  IduLogsListResponses,
  IduNightlifeVenueLinkData,
  IduNightlifeVenueLinkErrors,
  IduNightlifeVenueLinkResponses,
  IduNightlifeVenueLinkToData,
  IduNightlifeVenueLinkToErrors,
  IduNightlifeVenueLinkToResponses,
  IduNightlifeVenueListData,
  IduNightlifeVenueListErrors,
  IduNightlifeVenueListResponses,
  IduNightlifeVenueRelinkData,
  IduNightlifeVenueRelinkErrors,
  IduNightlifeVenueRelinkResponses,
  IduPayoutAuditData,
  IduPayoutAuditErrors,
  IduPayoutAuditResponses,
  IduPayoutCorrectionData,
  IduPayoutCorrectionErrors,
  IduPayoutCorrectionPreviewData,
  IduPayoutCorrectionPreviewErrors,
  IduPayoutCorrectionPreviewResponses,
  IduPayoutCorrectionResponses,
  IduPayoutDetailData,
  IduPayoutDetailErrors,
  IduPayoutDetailResponses,
  IduPayoutVenueMoveData,
  IduPayoutVenueMoveErrors,
  IduPayoutVenueMovePreviewData,
  IduPayoutVenueMovePreviewErrors,
  IduPayoutVenueMovePreviewResponses,
  IduPayoutVenueMoveResponses,
  IduPepCheckActivityListData,
  IduPepCheckActivityListErrors,
  IduPepCheckActivityListResponses,
  IduPepCheckRunStatsData,
  IduPepCheckRunStatsErrors,
  IduPepCheckRunStatsResponses,
  IduSettingsGetData,
  IduSettingsGetErrors,
  IduSettingsGetResponses,
  IduSettingsUpdateData,
  IduSettingsUpdateErrors,
  IduSettingsUpdateResponses,
  IduUserAssignToVenueData,
  IduUserAssignToVenueErrors,
  IduUserAssignToVenueResponses,
  IduUserCreateData,
  IduUserCreateErrors,
  IduUserCreateResponses,
  IduUserEmailSearchData,
  IduUserEmailSearchErrors,
  IduUserEmailSearchResponses,
  IduUserGetData,
  IduUserGetErrors,
  IduUserGetResponses,
  IduUserInviteCreateData,
  IduUserInviteCreateErrors,
  IduUserInviteCreateResponses,
  IduUserListData,
  IduUserListErrors,
  IduUserListResponses,
  IduUserPasswordChangeData,
  IduUserPasswordChangeErrors,
  IduUserPasswordChangeResponses,
  IduUserRemoveFromVenueData,
  IduUserRemoveFromVenueErrors,
  IduUserRemoveFromVenueResponses,
  IduUserResetPasswordData,
  IduUserResetPasswordErrors,
  IduUserResetPasswordResponses,
  IduUserSearchData,
  IduUserSearchErrors,
  IduUserSearchResponses,
  IduUserTwoStepCodeData,
  IduUserTwoStepCodeErrors,
  IduUserTwoStepCodeResponses,
  IduUserTwoStepData,
  IduUserTwoStepErrors,
  IduUserTwoStepResetData,
  IduUserTwoStepResetErrors,
  IduUserTwoStepResetResponses,
  IduUserTwoStepResponses,
  IduUserTwoStepUpdateData,
  IduUserTwoStepUpdateErrors,
  IduUserTwoStepUpdateResponses,
  IduUserUpdateData,
  IduUserUpdateErrors,
  IduUserUpdateResponses,
  IduVenueApplicationAssignData,
  IduVenueApplicationAssignErrors,
  IduVenueApplicationAssignResponses,
  IduVenueApplicationRemoveData,
  IduVenueApplicationRemoveErrors,
  IduVenueApplicationRemoveResponses,
  IduVenueCreateData,
  IduVenueCreateErrors,
  IduVenueCreateResponses,
  IduVenueGetData,
  IduVenueGetErrors,
  IduVenueGetResponses,
  IduVenueListData,
  IduVenueListErrors,
  IduVenueListResponses,
  IduVenueMwCredentialsStatusData,
  IduVenueMwCredentialsStatusErrors,
  IduVenueMwCredentialsStatusResponses,
  IduVenueMwCredentialsUpdateData,
  IduVenueMwCredentialsUpdateErrors,
  IduVenueMwCredentialsUpdateResponses,
  IduVenueNightlifeCreateData,
  IduVenueNightlifeCreateErrors,
  IduVenueNightlifeCreateResponses,
  IduVenueNightlifeLegacyManagersData,
  IduVenueNightlifeLegacyManagersErrors,
  IduVenueNightlifeLegacyManagersResponses,
  IduVenueNightlifeLinksData,
  IduVenueNightlifeLinksErrors,
  IduVenueNightlifeLinksResponses,
  IduVenueNightlifeSettingsGetData,
  IduVenueNightlifeSettingsGetErrors,
  IduVenueNightlifeSettingsGetResponses,
  IduVenueNightlifeSettingsUpdateData,
  IduVenueNightlifeSettingsUpdateErrors,
  IduVenueNightlifeSettingsUpdateResponses,
  IduVenueRolesListData,
  IduVenueRolesListErrors,
  IduVenueRolesListResponses,
  IduVenueUpdateData,
  IduVenueUpdateErrors,
  IduVenueUpdateResponses,
  IduVenueUsersListData,
  IduVenueUsersListErrors,
  IduVenueUsersListResponses,
  InAppMessageMarkReadData,
  InAppMessageMarkReadErrors,
  InAppMessageMarkReadResponses,
  InAppMessageUnreadForApplicationListData,
  InAppMessageUnreadForApplicationListErrors,
  InAppMessageUnreadForApplicationListResponses,
  InternalNightlifeGrantCreateData,
  InternalNightlifeGrantCreateErrors,
  InternalNightlifeGrantCreateResponses,
  LogCreateData,
  LogCreateErrors,
  LogCreateResponses,
  NightlifeManagerInviteData,
  NightlifeManagerInviteErrors,
  NightlifeManagerInviteResendData,
  NightlifeManagerInviteResendErrors,
  NightlifeManagerInviteResendResponses,
  NightlifeManagerInviteResponses,
  NightlifeManagerInviteRevokeData,
  NightlifeManagerInviteRevokeErrors,
  NightlifeManagerInviteRevokeResponses,
  NightlifeManagerListData,
  NightlifeManagerListErrors,
  NightlifeManagerListResponses,
  NightlifeManagerRemoveData,
  NightlifeManagerRemoveErrors,
  NightlifeManagerRemoveResponses,
  OauthProvisionData,
  OauthProvisionErrors,
  OauthProvisionResponses,
  PatronAuditTrailData,
  PatronAuditTrailErrors,
  PatronAuditTrailResponses,
  PatronCaptureAddData,
  PatronCaptureAddErrors,
  PatronCaptureAddResponses,
  PatronCaptureCompareData,
  PatronCaptureCompareErrors,
  PatronCaptureCompareResponses,
  PatronCreateData,
  PatronCreateErrors,
  PatronCreateResponses,
  PatronDetailsUpdateData,
  PatronDetailsUpdateErrors,
  PatronDetailsUpdateResponses,
  PatronDvsCheckRunData,
  PatronDvsCheckRunErrors,
  PatronDvsCheckRunResponses,
  PatronGetData,
  PatronGetErrors,
  PatronGetResponses,
  PatronIdentityCheckAttachData,
  PatronIdentityCheckAttachErrors,
  PatronIdentityCheckAttachResponses,
  PatronIdentityCheckDigitalData,
  PatronIdentityCheckDigitalErrors,
  PatronIdentityCheckDigitalResponses,
  PatronListData,
  PatronListErrors,
  PatronListResponses,
  PatronPepCheckDecideData,
  PatronPepCheckDecideErrors,
  PatronPepCheckDecideResponses,
  PatronPepCheckRunData,
  PatronPepCheckRunErrors,
  PatronPepCheckRunResponses,
  PatronSearchData,
  PatronSearchErrors,
  PatronSearchResponses,
  PatronTypeUpdateData,
  PatronTypeUpdateErrors,
  PatronTypeUpdateResponses,
  PayoutAuditTrailData,
  PayoutAuditTrailErrors,
  PayoutAuditTrailResponses,
  PayoutConfirmationOfPayeeNotesUpdateData,
  PayoutConfirmationOfPayeeNotesUpdateErrors,
  PayoutConfirmationOfPayeeNotesUpdateResponses,
  PayoutConfirmationOfPayeeReVerifyData,
  PayoutConfirmationOfPayeeReVerifyErrors,
  PayoutConfirmationOfPayeeReVerifyResponses,
  PayoutConfirmationOfPayeeVerifyData,
  PayoutConfirmationOfPayeeVerifyErrors,
  PayoutConfirmationOfPayeeVerifyResponses,
  PayoutConnectIdShortLinkData,
  PayoutConnectIdShortLinkErrors,
  PayoutConnectIdVerificationCancelData,
  PayoutConnectIdVerificationCancelErrors,
  PayoutConnectIdVerificationCancelResponses,
  PayoutConnectIdVerificationStartData,
  PayoutConnectIdVerificationStartErrors,
  PayoutConnectIdVerificationStartResponses,
  PayoutConnectIdVerificationStatusData,
  PayoutConnectIdVerificationStatusErrors,
  PayoutConnectIdVerificationStatusResponses,
  PayoutCreateData,
  PayoutCreateErrors,
  PayoutCreateResponses,
  PayoutDiscardData,
  PayoutDiscardErrors,
  PayoutDiscardResponses,
  PayoutGetData,
  PayoutGetErrors,
  PayoutGetResponses,
  PayoutIdentityCheckDigitalData,
  PayoutIdentityCheckDigitalErrors,
  PayoutIdentityCheckDigitalResponses,
  PayoutListData,
  PayoutListErrors,
  PayoutListResponses,
  PayoutManagerElevationRefreshData,
  PayoutManagerElevationRefreshErrors,
  PayoutManagerElevationRefreshResponses,
  PayoutManagerReviewGetData,
  PayoutManagerReviewGetErrors,
  PayoutManagerReviewGetResponses,
  PayoutManagerReviewPostData,
  PayoutManagerReviewPostErrors,
  PayoutManagerReviewPostResponses,
  PayoutPhase1PatronIdData,
  PayoutPhase1PatronIdErrors,
  PayoutPhase1PatronIdResponses,
  PayoutPhase2TicketData,
  PayoutPhase2TicketErrors,
  PayoutPhase2TicketResponses,
  PayoutPhase3KycData,
  PayoutPhase3KycErrors,
  PayoutPhase3KycResponses,
  PayoutPhase3KycVerifyData,
  PayoutPhase3KycVerifyErrors,
  PayoutPhase3KycVerifyResponses,
  PayoutPhase4ContactPaymentData,
  PayoutPhase4ContactPaymentErrors,
  PayoutPhase4ContactPaymentResponses,
  PayoutPhase5PatronSignOffData,
  PayoutPhase5PatronSignOffErrors,
  PayoutPhase5PatronSignOffResponses,
  PayoutPhase6AttendantSignOffData,
  PayoutPhase6AttendantSignOffErrors,
  PayoutPhase6AttendantSignOffResponses,
  PayoutPhase7ManagerSignOffData,
  PayoutPhase7ManagerSignOffErrors,
  PayoutPhase7ManagerSignOffResponses,
  PayoutPhase8PayoutData,
  PayoutPhase8PayoutErrors,
  PayoutPhase8PayoutResponses,
  PayoutReceiptSendData,
  PayoutReceiptSendErrors,
  PayoutReceiptSendResponses,
  PayoutUpdateData,
  PayoutUpdateErrors,
  PayoutUpdateResponses,
  PayoutViewData,
  PayoutViewErrors,
  PayoutViewResponses,
  PermissionCatalogueListData,
  PermissionCatalogueListErrors,
  PermissionCatalogueListResponses,
  PokieVenueSettingGetData,
  PokieVenueSettingGetErrors,
  PokieVenueSettingGetResponses,
  PokieVenueSettingRiskRuleListData,
  PokieVenueSettingRiskRuleListErrors,
  PokieVenueSettingRiskRuleListResponses,
  PokieVenueSettingUpdateData,
  PokieVenueSettingUpdateErrors,
  PokieVenueSettingUpdateResponses,
  PpUserInviteData,
  PpUserInviteErrors,
  PpUserInviteResponses,
  PpUserReinviteData,
  PpUserReinviteErrors,
  PpUserReinviteResponses,
  PpUserRevokeInviteData,
  PpUserRevokeInviteErrors,
  PpUserRevokeInviteResponses,
  PpVenueUserCreateData,
  PpVenueUserCreateErrors,
  PpVenueUserCreateResponses,
  PpVenueUserDeleteData,
  PpVenueUserDeleteErrors,
  PpVenueUserDeleteResponses,
  PpVenueUserGetData,
  PpVenueUserGetErrors,
  PpVenueUserGetResponses,
  PpVenueUserListData,
  PpVenueUserListErrors,
  PpVenueUserListResponses,
  PpVenueUserUpdateData,
  PpVenueUserUpdateErrors,
  PpVenueUserUpdateResponses,
  ResetPasswordData,
  ResetPasswordErrors,
  ResetPasswordResponses,
  RiskRegisterAttachmentCreateData,
  RiskRegisterAttachmentCreateErrors,
  RiskRegisterAttachmentCreateResponses,
  RiskRegisterAttachmentDeleteData,
  RiskRegisterAttachmentDeleteErrors,
  RiskRegisterAttachmentDeleteResponses,
  RiskRegisterAttachmentGetData,
  RiskRegisterAttachmentGetErrors,
  RiskRegisterAttachmentGetResponses,
  RiskRegisterCreateData,
  RiskRegisterCreateErrors,
  RiskRegisterCreateResponses,
  RiskRegisterListData,
  RiskRegisterListErrors,
  RiskRegisterListResponses,
  RiskRegisterMetricsData,
  RiskRegisterMetricsErrors,
  RiskRegisterMetricsResponses,
  RiskRegisterPatronSearchData,
  RiskRegisterPatronSearchErrors,
  RiskRegisterPatronSearchResponses,
  RiskRegisterPayoutSearchData,
  RiskRegisterPayoutSearchErrors,
  RiskRegisterPayoutSearchResponses,
  RiskRegisterReviewData,
  RiskRegisterReviewErrors,
  RiskRegisterReviewResponses,
  ScanLicenseData,
  ScanLicenseErrors,
  ScanLicenseResponses,
  SelfProfileGetData,
  SelfProfileGetErrors,
  SelfProfileGetResponses,
  SelfProfileUpdateData,
  SelfProfileUpdateErrors,
  SelfProfileUpdateResponses,
  StaffAccessData,
  StaffAccessErrors,
  StaffAccessResponses,
  TwoStepConfirmMethodData,
  TwoStepConfirmMethodErrors,
  TwoStepConfirmMethodResponses,
  TwoStepForgetAllDevicesData,
  TwoStepForgetAllDevicesErrors,
  TwoStepForgetAllDevicesResponses,
  TwoStepForgetDeviceData,
  TwoStepForgetDeviceErrors,
  TwoStepForgetDeviceResponses,
  TwoStepListDevicesData,
  TwoStepListDevicesErrors,
  TwoStepListDevicesResponses,
  TwoStepRemoveMethodData,
  TwoStepRemoveMethodErrors,
  TwoStepRemoveMethodResponses,
  TwoStepRequireData,
  TwoStepRequireErrors,
  TwoStepRequireResponses,
  TwoStepSendCodeData,
  TwoStepSendCodeErrors,
  TwoStepSendCodeResponses,
  TwoStepSetChoiceData,
  TwoStepSetChoiceErrors,
  TwoStepSetChoiceResponses,
  TwoStepSetPreferredData,
  TwoStepSetPreferredErrors,
  TwoStepSetPreferredResponses,
  TwoStepStartAuthenticatorData,
  TwoStepStartAuthenticatorErrors,
  TwoStepStartAuthenticatorResponses,
  TwoStepStartSmsData,
  TwoStepStartSmsErrors,
  TwoStepStartSmsResponses,
  TwoStepStatusData,
  TwoStepStatusErrors,
  TwoStepStatusResponses,
  TwoStepVerifyData,
  TwoStepVerifyDeviceData,
  TwoStepVerifyDeviceErrors,
  TwoStepVerifyDeviceResponses,
  TwoStepVerifyErrors,
  TwoStepVerifyResponses,
  UserGetDataData,
  UserGetDataErrors,
  UserGetDataResponses,
  UserPinCheckData,
  UserPinCheckErrors,
  UserPinCheckResponses,
  UserPublicProfileData,
  UserPublicProfileErrors,
  UserPublicProfileResponses,
  UserUpdateProfileData,
  UserUpdateProfileErrors,
  UserUpdateProfileResponses,
  VenueAssignableRoleListData,
  VenueAssignableRoleListErrors,
  VenueAssignableRoleListResponses,
  VenueRoleCreateData,
  VenueRoleCreateErrors,
  VenueRoleCreateResponses,
  VenueRoleDeleteData,
  VenueRoleDeleteErrors,
  VenueRoleDeleteResponses,
  VenueRoleGetData,
  VenueRoleGetErrors,
  VenueRoleGetResponses,
  VenueRoleListData,
  VenueRoleListErrors,
  VenueRoleListResponses,
  VenueRolePermissionsUpdateData,
  VenueRolePermissionsUpdateErrors,
  VenueRolePermissionsUpdateResponses,
  VenueRoleUpdateData,
  VenueRoleUpdateErrors,
  VenueRoleUpdateResponses,
  VoiSettingGetData,
  VoiSettingGetErrors,
  VoiSettingGetResponses,
  VoiSettingUpdateData,
  VoiSettingUpdateErrors,
  VoiSettingUpdateResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health endpoint
 *
 * Get server information and status.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
): RequestResult<GetHealthResponses, GetHealthErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetHealthResponses, GetHealthErrors, ThrowOnError>({
    url: '/api/v1/public/health',
    ...options,
  });

/**
 * Platform feature flags
 *
 * Platform-wide feature flags the frontends must mirror.
 */
export const getFeatureFlags = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeatureFlagsData, ThrowOnError>,
): RequestResult<GetFeatureFlagsResponses, GetFeatureFlagsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetFeatureFlagsResponses, GetFeatureFlagsErrors, ThrowOnError>({
    url: '/api/v1/public/feature-flags',
    ...options,
  });

/**
 * Log
 *
 * Log
 */
export const logCreate = <ThrowOnError extends boolean = false>(
  options: Options<LogCreateData, ThrowOnError>,
): RequestResult<LogCreateResponses, LogCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<LogCreateResponses, LogCreateErrors, ThrowOnError>({
    url: '/api/v1/public/log',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reset password
 *
 * Request to reset the users password via email address
 */
export const resetPassword = <ThrowOnError extends boolean = false>(
  options: Options<ResetPasswordData, ThrowOnError>,
): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> =>
  (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/api/v1/public/reset-password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Signup User
 *
 * Request to signup user
 */
export const authSignup = <ThrowOnError extends boolean = false>(
  options: Options<AuthSignupData, ThrowOnError>,
): RequestResult<AuthSignupResponses, AuthSignupErrors, ThrowOnError> =>
  (options.client ?? client).post<AuthSignupResponses, AuthSignupErrors, ThrowOnError>({
    url: '/api/v1/public/signup',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Provision an OAuth sign-up
 *
 * Create-or-merge the DB user for a freshly OAuth-authenticated Firebase identity.
 */
export const oauthProvision = <ThrowOnError extends boolean = false>(
  options?: Options<OauthProvisionData, ThrowOnError>,
): RequestResult<OauthProvisionResponses, OauthProvisionErrors, ThrowOnError> =>
  (options?.client ?? client).post<OauthProvisionResponses, OauthProvisionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/oauth-provision',
    ...options,
  });

/**
 * Signup User with Invite Id
 *
 * Request to sign up user with a signed token
 */
export const authAcceptInviteNewUser = <ThrowOnError extends boolean = false>(
  options: Options<AuthAcceptInviteNewUserData, ThrowOnError>,
): RequestResult<AuthAcceptInviteNewUserResponses, AuthAcceptInviteNewUserErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AuthAcceptInviteNewUserResponses,
    AuthAcceptInviteNewUserErrors,
    ThrowOnError
  >({
    url: '/api/v1/public/accept-invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Signup User with Invite Id
 *
 * Request to sign up user with a signed token
 */
export const authAcceptInviteExistingUser = <ThrowOnError extends boolean = false>(
  options: Options<AuthAcceptInviteExistingUserData, ThrowOnError>,
): RequestResult<
  AuthAcceptInviteExistingUserResponses,
  AuthAcceptInviteExistingUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AuthAcceptInviteExistingUserResponses,
    AuthAcceptInviteExistingUserErrors,
    ThrowOnError
  >({ url: '/api/v1/public/accept-invite-existing', ...options });

/**
 * Signup User with Invite Id
 *
 * Request to sign up user with a signed token
 */
export const authCheckInvite = <ThrowOnError extends boolean = false>(
  options: Options<AuthCheckInviteData, ThrowOnError>,
): RequestResult<AuthCheckInviteResponses, AuthCheckInviteErrors, ThrowOnError> =>
  (options.client ?? client).get<AuthCheckInviteResponses, AuthCheckInviteErrors, ThrowOnError>({
    url: '/api/v1/public/check-invite',
    ...options,
  });

/**
 * Get two-step sign-in status
 */
export const twoStepStatus = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepStatusData, ThrowOnError>,
): RequestResult<TwoStepStatusResponses, TwoStepStatusErrors, ThrowOnError> =>
  (options?.client ?? client).get<TwoStepStatusResponses, TwoStepStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step',
    ...options,
  });

/**
 * Turn two-step sign-in on or off
 */
export const twoStepSetChoice = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepSetChoiceData, ThrowOnError>,
): RequestResult<TwoStepSetChoiceResponses, TwoStepSetChoiceErrors, ThrowOnError> =>
  (options?.client ?? client).patch<
    TwoStepSetChoiceResponses,
    TwoStepSetChoiceErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Require two-step sign-in for the signed-in account
 */
export const twoStepRequire = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepRequireData, ThrowOnError>,
): RequestResult<TwoStepRequireResponses, TwoStepRequireErrors, ThrowOnError> =>
  (options?.client ?? client).post<TwoStepRequireResponses, TwoStepRequireErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/requirement',
    ...options,
  });

/**
 * Start setting up an authenticator app
 */
export const twoStepStartAuthenticator = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepStartAuthenticatorData, ThrowOnError>,
): RequestResult<
  TwoStepStartAuthenticatorResponses,
  TwoStepStartAuthenticatorErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    TwoStepStartAuthenticatorResponses,
    TwoStepStartAuthenticatorErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/methods/authenticator',
    ...options,
  });

/**
 * Start setting up text message codes, or changing their number
 *
 * On text messages already set up, this starts changing the number and needs a passed second step. The code goes to the new number, and the old number keeps working until the new one is confirmed.
 */
export const twoStepStartSms = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepStartSmsData, ThrowOnError>,
): RequestResult<TwoStepStartSmsResponses, TwoStepStartSmsErrors, ThrowOnError> =>
  (options?.client ?? client).post<TwoStepStartSmsResponses, TwoStepStartSmsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/methods/sms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Confirm a method with its first code
 *
 * Also confirms a text message number change, with the code sent to the new number. Remembered devices are then forgotten.
 */
export const twoStepConfirmMethod = <ThrowOnError extends boolean = false>(
  options: Options<TwoStepConfirmMethodData, ThrowOnError>,
): RequestResult<TwoStepConfirmMethodResponses, TwoStepConfirmMethodErrors, ThrowOnError> =>
  (options.client ?? client).post<
    TwoStepConfirmMethodResponses,
    TwoStepConfirmMethodErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/methods/{kind}/confirmation',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a method
 */
export const twoStepRemoveMethod = <ThrowOnError extends boolean = false>(
  options: Options<TwoStepRemoveMethodData, ThrowOnError>,
): RequestResult<TwoStepRemoveMethodResponses, TwoStepRemoveMethodErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    TwoStepRemoveMethodResponses,
    TwoStepRemoveMethodErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/methods/{kind}',
    ...options,
  });

/**
 * Make a method the one asked for first
 */
export const twoStepSetPreferred = <ThrowOnError extends boolean = false>(
  options: Options<TwoStepSetPreferredData, ThrowOnError>,
): RequestResult<TwoStepSetPreferredResponses, TwoStepSetPreferredErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    TwoStepSetPreferredResponses,
    TwoStepSetPreferredErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/methods/{kind}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Send a sign-in code by text message
 */
export const twoStepSendCode = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepSendCodeData, ThrowOnError>,
): RequestResult<TwoStepSendCodeResponses, TwoStepSendCodeErrors, ThrowOnError> =>
  (options?.client ?? client).post<TwoStepSendCodeResponses, TwoStepSendCodeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/codes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Pass the second step for this sign-in
 */
export const twoStepVerify = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepVerifyData, ThrowOnError>,
): RequestResult<TwoStepVerifyResponses, TwoStepVerifyErrors, ThrowOnError> =>
  (options?.client ?? client).post<TwoStepVerifyResponses, TwoStepVerifyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/verifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Pass the second step on a remembered device
 */
export const twoStepVerifyDevice = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepVerifyDeviceData, ThrowOnError>,
): RequestResult<TwoStepVerifyDeviceResponses, TwoStepVerifyDeviceErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    TwoStepVerifyDeviceResponses,
    TwoStepVerifyDeviceErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/device-verifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Forget every remembered device
 */
export const twoStepForgetAllDevices = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepForgetAllDevicesData, ThrowOnError>,
): RequestResult<TwoStepForgetAllDevicesResponses, TwoStepForgetAllDevicesErrors, ThrowOnError> =>
  (options?.client ?? client).delete<
    TwoStepForgetAllDevicesResponses,
    TwoStepForgetAllDevicesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/devices',
    ...options,
  });

/**
 * List the remembered devices
 */
export const twoStepListDevices = <ThrowOnError extends boolean = false>(
  options?: Options<TwoStepListDevicesData, ThrowOnError>,
): RequestResult<TwoStepListDevicesResponses, TwoStepListDevicesErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    TwoStepListDevicesResponses,
    TwoStepListDevicesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/devices',
    ...options,
  });

/**
 * Forget one remembered device
 */
export const twoStepForgetDevice = <ThrowOnError extends boolean = false>(
  options: Options<TwoStepForgetDeviceData, ThrowOnError>,
): RequestResult<TwoStepForgetDeviceResponses, TwoStepForgetDeviceErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    TwoStepForgetDeviceResponses,
    TwoStepForgetDeviceErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/two-step/devices/{id}',
    ...options,
  });

/**
 * Whether the signed-in account is iDU staff (holds iDU Dashboard access)
 */
export const staffAccess = <ThrowOnError extends boolean = false>(
  options?: Options<StaffAccessData, ThrowOnError>,
): RequestResult<StaffAccessResponses, StaffAccessErrors, ThrowOnError> =>
  (options?.client ?? client).get<StaffAccessResponses, StaffAccessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/public/staff-access',
    ...options,
  });

/**
 * Get public user info
 *
 * Retrieve the user you are authenticated as
 */
export const userPublicProfile = <ThrowOnError extends boolean = false>(
  options: Options<UserPublicProfileData, ThrowOnError>,
): RequestResult<UserPublicProfileResponses, UserPublicProfileErrors, ThrowOnError> =>
  (options.client ?? client).get<UserPublicProfileResponses, UserPublicProfileErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/users/{userId}/profile',
      ...options,
    },
  );

/**
 * Scan a digital license
 *
 * Scan and validate a VIC Roads or Service Victoria digital credential
 */
export const scanLicense = <ThrowOnError extends boolean = false>(
  options: Options<ScanLicenseData, ThrowOnError>,
): RequestResult<ScanLicenseResponses, ScanLicenseErrors, ThrowOnError> =>
  (options.client ?? client).post<ScanLicenseResponses, ScanLicenseErrors, ThrowOnError>({
    url: '/api/v1/scan/vic-digital',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get user tied to auth
 *
 * Retrieve the currently authenticated user and their venues.
 */
export const getSelfAppData = <ThrowOnError extends boolean = false>(
  options?: Options<GetSelfAppDataData, ThrowOnError>,
): RequestResult<GetSelfAppDataResponses, GetSelfAppDataErrors, ThrowOnError> =>
  (options?.client ?? client).get<GetSelfAppDataResponses, GetSelfAppDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/self',
    ...options,
  });

/**
 * Get your profile
 *
 * Retrieve the authenticated caller's own profile
 */
export const selfProfileGet = <ThrowOnError extends boolean = false>(
  options?: Options<SelfProfileGetData, ThrowOnError>,
): RequestResult<SelfProfileGetResponses, SelfProfileGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<SelfProfileGetResponses, SelfProfileGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/self/profile',
    ...options,
  });

/**
 * Update your profile
 *
 * Update the authenticated caller's own profile and access PIN
 */
export const selfProfileUpdate = <ThrowOnError extends boolean = false>(
  options?: Options<SelfProfileUpdateData, ThrowOnError>,
): RequestResult<SelfProfileUpdateResponses, SelfProfileUpdateErrors, ThrowOnError> =>
  (options?.client ?? client).put<
    SelfProfileUpdateResponses,
    SelfProfileUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/self/profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Get your profile
 *
 * Retrieve the authenticated caller's own profile
 *
 * @deprecated
 */
export const userGetData = <ThrowOnError extends boolean = false>(
  options?: Options<UserGetDataData, ThrowOnError>,
): RequestResult<UserGetDataResponses, UserGetDataErrors, ThrowOnError> =>
  (options?.client ?? client).get<UserGetDataResponses, UserGetDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ir/self/edit',
    ...options,
  });

/**
 * Update your profile
 *
 * Update the authenticated caller's own profile and access PIN
 *
 * @deprecated
 */
export const userUpdateProfile = <ThrowOnError extends boolean = false>(
  options?: Options<UserUpdateProfileData, ThrowOnError>,
): RequestResult<UserUpdateProfileResponses, UserUpdateProfileErrors, ThrowOnError> =>
  (options?.client ?? client).put<
    UserUpdateProfileResponses,
    UserUpdateProfileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/ir/self',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * List in-app messages
 *
 * List all in-app messages
 */
export const inAppMessageUnreadForApplicationList = <ThrowOnError extends boolean = false>(
  options: Options<InAppMessageUnreadForApplicationListData, ThrowOnError>,
): RequestResult<
  InAppMessageUnreadForApplicationListResponses,
  InAppMessageUnreadForApplicationListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    InAppMessageUnreadForApplicationListResponses,
    InAppMessageUnreadForApplicationListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/self/in-app-messages/unread',
    ...options,
  });

/**
 * Mark in-app messages as read
 *
 * Mark one or more in-app messages as read for the authenticated user
 */
export const inAppMessageMarkRead = <ThrowOnError extends boolean = false>(
  options?: Options<InAppMessageMarkReadData, ThrowOnError>,
): RequestResult<InAppMessageMarkReadResponses, InAppMessageMarkReadErrors, ThrowOnError> =>
  (options?.client ?? client).put<
    InAppMessageMarkReadResponses,
    InAppMessageMarkReadErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/self/in-app-messages/read',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

/**
 * Lookup Table Retrieve One / Many
 *
 * Allows you to retrieve the values from one or many lookup tables
 */
export const getLookupTableValues = <ThrowOnError extends boolean = false>(
  options: Options<GetLookupTableValuesData, ThrowOnError>,
): RequestResult<GetLookupTableValuesResponses, GetLookupTableValuesErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GetLookupTableValuesResponses,
    GetLookupTableValuesErrors,
    ThrowOnError
  >({ url: '/api/v1/appdata/lookup-values', ...options });

/**
 * File Upload Intent
 *
 * File Upload Intent
 */
export const fileUploadIntent = <ThrowOnError extends boolean = false>(
  options?: Options<FileUploadIntentData, ThrowOnError>,
): RequestResult<FileUploadIntentResponses, FileUploadIntentErrors, ThrowOnError> =>
  (options?.client ?? client).post<FileUploadIntentResponses, FileUploadIntentErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/file/upload-url',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );

/**
 * returns a redirect to the signed file url
 */
export const fileView = <ThrowOnError extends boolean = false>(
  options: Options<FileViewData, ThrowOnError>,
): RequestResult<unknown, FileViewErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, FileViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/file/{fileId}/view',
    ...options,
  });

export const payoutConnectIdShortLink = <ThrowOnError extends boolean = false>(
  options: Options<PayoutConnectIdShortLinkData, ThrowOnError>,
): RequestResult<unknown, PayoutConnectIdShortLinkErrors, ThrowOnError> =>
  (options.client ?? client).get<unknown, PayoutConnectIdShortLinkErrors, ThrowOnError>({
    url: '/api/v1/pp/public/connectid/{code}',
    ...options,
  });

/**
 * Propose a structured breakdown of a patron address
 *
 * Validates an address entered during payout capture and returns the structured parts with per-part provenance. Every refusal — the venue is not on automated EFT, the platform switch is off, the per-venue ceiling is exceeded, or the provider errored or exceeded its deadline — answers `available: false` and names itself in `cause` for the audit record (FR-024), and none of them blocks capture (FR-008). An address the validator ran against but matched to no real place answers `available: true` with `resolved: false`, which does block capture until the parts are entered manually (FR-008a).
 */
export const checkdAddressValidate = <ThrowOnError extends boolean = false>(
  options: Options<CheckdAddressValidateData, ThrowOnError>,
): RequestResult<CheckdAddressValidateResponses, CheckdAddressValidateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    CheckdAddressValidateResponses,
    CheckdAddressValidateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/address/validate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Payouts
 *
 * Retrieve paginated list of payouts for venue
 */
export const payoutList = <ThrowOnError extends boolean = false>(
  options: Options<PayoutListData, ThrowOnError>,
): RequestResult<PayoutListResponses, PayoutListErrors, ThrowOnError> =>
  (options.client ?? client).get<PayoutListResponses, PayoutListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout',
    ...options,
  });

/**
 * Create Payout with Ticket Details
 *
 * Create a new payout with ticket photo and details
 */
export const payoutCreate = <ThrowOnError extends boolean = false>(
  options: Options<PayoutCreateData, ThrowOnError>,
): RequestResult<PayoutCreateResponses, PayoutCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<PayoutCreateResponses, PayoutCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Payout
 *
 * Retrieve a payout for a venue
 */
export const payoutGet = <ThrowOnError extends boolean = false>(
  options: Options<PayoutGetData, ThrowOnError>,
): RequestResult<PayoutGetResponses, PayoutGetErrors, ThrowOnError> =>
  (options.client ?? client).get<PayoutGetResponses, PayoutGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}',
    ...options,
  });

/**
 * Update Payout
 *
 * Allows a manager to correct patron name, ID info, or payment details on a payout. Staff may do so only while elevated, sending the manager PIN login's token in x-temporary-manager-token. If patron name changes, the linked patron record is unlinked. If patron name or ID info changes, the KYC DVS outcome is cleared to allow re-verification. The response includes full payout state so the frontend can detect KYC breakage via payoutState.
 */
export const payoutUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PayoutUpdateData, ThrowOnError>,
): RequestResult<PayoutUpdateResponses, PayoutUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<PayoutUpdateResponses, PayoutUpdateErrors, ThrowOnError>({
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Record Payout View
 *
 * Record that the authenticated user viewed a payout
 */
export const payoutView = <ThrowOnError extends boolean = false>(
  options: Options<PayoutViewData, ThrowOnError>,
): RequestResult<PayoutViewResponses, PayoutViewErrors, ThrowOnError> =>
  (options.client ?? client).post<PayoutViewResponses, PayoutViewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/view',
    ...options,
  });

/**
 * Summary
 *
 * Description
 */
export const payoutReceiptSend = <ThrowOnError extends boolean = false>(
  options: Options<PayoutReceiptSendData, ThrowOnError>,
): RequestResult<PayoutReceiptSendResponses, PayoutReceiptSendErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PayoutReceiptSendResponses,
    PayoutReceiptSendErrors,
    ThrowOnError
  >({
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/receipt/send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Phase : Patron Identification
 *
 * Update patron identification details and KYC requirement flag
 */
export const payoutPhase1PatronId = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase1PatronIdData, ThrowOnError>,
): RequestResult<PayoutPhase1PatronIdResponses, PayoutPhase1PatronIdErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PayoutPhase1PatronIdResponses,
    PayoutPhase1PatronIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/1-patron-id',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify a digital licence on a payout
 *
 * Verifies a QLD or VIC digital licence, writes its identity onto the payout, and records the payout's identity check
 */
export const payoutIdentityCheckDigital = <ThrowOnError extends boolean = false>(
  options: Options<PayoutIdentityCheckDigitalData, ThrowOnError>,
): RequestResult<
  PayoutIdentityCheckDigitalResponses,
  PayoutIdentityCheckDigitalErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PayoutIdentityCheckDigitalResponses,
    PayoutIdentityCheckDigitalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/identity-check/digital',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Cancel a payout’s ConnectID verification
 *
 * FR-013a — returns the payout to the ordinary identity-capture flow so the attendant can proceed with a document scan. The vendor operation is abandoned, not reversed.
 */
export const payoutConnectIdVerificationCancel = <ThrowOnError extends boolean = false>(
  options: Options<PayoutConnectIdVerificationCancelData, ThrowOnError>,
): RequestResult<
  PayoutConnectIdVerificationCancelResponses,
  PayoutConnectIdVerificationCancelErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    PayoutConnectIdVerificationCancelResponses,
    PayoutConnectIdVerificationCancelErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/connectid-verification',
    ...options,
  });

/**
 * Read the current state of a payout’s ConnectID verification
 *
 * The attendant’s device polls this rather than the vendor (research R8), and re-reads it on foreground so a backgrounded tablet resumes rather than restarting (FR-027).
 */
export const payoutConnectIdVerificationStatus = <ThrowOnError extends boolean = false>(
  options: Options<PayoutConnectIdVerificationStatusData, ThrowOnError>,
): RequestResult<
  PayoutConnectIdVerificationStatusResponses,
  PayoutConnectIdVerificationStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PayoutConnectIdVerificationStatusResponses,
    PayoutConnectIdVerificationStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/connectid-verification',
    ...options,
  });

/**
 * Start a ConnectID identity verification for a payout
 *
 * Creates or reuses the payout’s vendor entity from the seed name and runs the ConnectID job against it, returning the vendor-issued destination the patron scans.
 */
export const payoutConnectIdVerificationStart = <ThrowOnError extends boolean = false>(
  options: Options<PayoutConnectIdVerificationStartData, ThrowOnError>,
): RequestResult<
  PayoutConnectIdVerificationStartResponses,
  PayoutConnectIdVerificationStartErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PayoutConnectIdVerificationStartResponses,
    PayoutConnectIdVerificationStartErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/connectid-verification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Phase 2: Ticket Details
 *
 * Update ticket photo and ticket details
 */
export const payoutPhase2Ticket = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase2TicketData, ThrowOnError>,
): RequestResult<PayoutPhase2TicketResponses, PayoutPhase2TicketErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PayoutPhase2TicketResponses,
    PayoutPhase2TicketErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/2-ticket',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Phase 3: KYC
 *
 * Submit patron signature and documents
 */
export const payoutPhase3Kyc = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase3KycData, ThrowOnError>,
): RequestResult<PayoutPhase3KycResponses, PayoutPhase3KycErrors, ThrowOnError> =>
  (options.client ?? client).patch<PayoutPhase3KycResponses, PayoutPhase3KycErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/3-kyc',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Trigger DVS verification for payout
 *
 * Run DVS/NCC verification and persist outcome
 */
export const payoutPhase3KycVerify = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase3KycVerifyData, ThrowOnError>,
): RequestResult<PayoutPhase3KycVerifyResponses, PayoutPhase3KycVerifyErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PayoutPhase3KycVerifyResponses,
    PayoutPhase3KycVerifyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/3-kyc/verify',
    ...options,
  });

/**
 * Update Phase 4: Contact & Payment Methods
 *
 * Update patron contact details and payment method preferences
 */
export const payoutPhase4ContactPayment = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase4ContactPaymentData, ThrowOnError>,
): RequestResult<
  PayoutPhase4ContactPaymentResponses,
  PayoutPhase4ContactPaymentErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PayoutPhase4ContactPaymentResponses,
    PayoutPhase4ContactPaymentErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/4-contact-payment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify Confirmation of Payee for a payout (Staff-facing venues)
 *
 * Attendant-triggered check against the BSB/account number/account name currently entered in the Phase 4 form (not yet saved to the payout), used only at Staff-facing venues.
 */
export const payoutConfirmationOfPayeeVerify = <ThrowOnError extends boolean = false>(
  options: Options<PayoutConfirmationOfPayeeVerifyData, ThrowOnError>,
): RequestResult<
  PayoutConfirmationOfPayeeVerifyResponses,
  PayoutConfirmationOfPayeeVerifyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PayoutConfirmationOfPayeeVerifyResponses,
    PayoutConfirmationOfPayeeVerifyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/4-contact-payment/confirmation-of-payee/verify',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Re-verify Confirmation of Payee for a payout under review
 *
 * Manager-triggered check, used after editing the patron banking details during payout review to clear the stale state on the KYC assessment chip.
 */
export const payoutConfirmationOfPayeeReVerify = <ThrowOnError extends boolean = false>(
  options: Options<PayoutConfirmationOfPayeeReVerifyData, ThrowOnError>,
): RequestResult<
  PayoutConfirmationOfPayeeReVerifyResponses,
  PayoutConfirmationOfPayeeReVerifyErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PayoutConfirmationOfPayeeReVerifyResponses,
    PayoutConfirmationOfPayeeReVerifyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/4-contact-payment/confirmation-of-payee/re-verify',
    ...options,
  });

/**
 * Save free-text notes against the payout's latest Confirmation of Payee result
 */
export const payoutConfirmationOfPayeeNotesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PayoutConfirmationOfPayeeNotesUpdateData, ThrowOnError>,
): RequestResult<
  PayoutConfirmationOfPayeeNotesUpdateResponses,
  PayoutConfirmationOfPayeeNotesUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PayoutConfirmationOfPayeeNotesUpdateResponses,
    PayoutConfirmationOfPayeeNotesUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/4-contact-payment/confirmation-of-payee/notes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Phase 5: Patron
 *
 * Collect patron signature for payout confirmation
 */
export const payoutPhase5PatronSignOff = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase5PatronSignOffData, ThrowOnError>,
): RequestResult<
  PayoutPhase5PatronSignOffResponses,
  PayoutPhase5PatronSignOffErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PayoutPhase5PatronSignOffResponses,
    PayoutPhase5PatronSignOffErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/5-patron-sign-off',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Phase 6: Attendant Signatures
 *
 * Collect attendant signature for payout confirmation
 */
export const payoutPhase6AttendantSignOff = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase6AttendantSignOffData, ThrowOnError>,
): RequestResult<
  PayoutPhase6AttendantSignOffResponses,
  PayoutPhase6AttendantSignOffErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PayoutPhase6AttendantSignOffResponses,
    PayoutPhase6AttendantSignOffErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/6-attendant-sign-off',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Manager Review State
 *
 * Orchestrates the manager review process (Patron Linking -> PEP Check -> Sign Off)
 */
export const payoutManagerReviewGet = <ThrowOnError extends boolean = false>(
  options: Options<PayoutManagerReviewGetData, ThrowOnError>,
): RequestResult<PayoutManagerReviewGetResponses, PayoutManagerReviewGetErrors, ThrowOnError> =>
  (options.client ?? client).get<
    PayoutManagerReviewGetResponses,
    PayoutManagerReviewGetErrors,
    ThrowOnError
  >({ url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/review', ...options });

/**
 * Submit Manager Review Action
 *
 * Execute actions for the manager review process
 */
export const payoutManagerReviewPost = <ThrowOnError extends boolean = false>(
  options: Options<PayoutManagerReviewPostData, ThrowOnError>,
): RequestResult<PayoutManagerReviewPostResponses, PayoutManagerReviewPostErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PayoutManagerReviewPostResponses,
    PayoutManagerReviewPostErrors,
    ThrowOnError
  >({
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Extend a manager PIN elevation that is still in use
 *
 * Re-issues the temporary manager token for the same manager, attendant and payout with a fresh idle expiry, capped at a fixed time after the PIN was entered. Refused once expired or capped.
 */
export const payoutManagerElevationRefresh = <ThrowOnError extends boolean = false>(
  options: Options<PayoutManagerElevationRefreshData, ThrowOnError>,
): RequestResult<
  PayoutManagerElevationRefreshResponses,
  PayoutManagerElevationRefreshErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    PayoutManagerElevationRefreshResponses,
    PayoutManagerElevationRefreshErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/manager-elevation/refresh',
    ...options,
  });

/**
 * Update Phase 7: Manager Approval
 *
 * Submit manager signature to approve payout for processing
 */
export const payoutPhase7ManagerSignOff = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase7ManagerSignOffData, ThrowOnError>,
): RequestResult<
  PayoutPhase7ManagerSignOffResponses,
  PayoutPhase7ManagerSignOffErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    PayoutPhase7ManagerSignOffResponses,
    PayoutPhase7ManagerSignOffErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/7-manager-sign-off',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Phase 8: Payouts
 *
 * Record payment confirmations for cash, EFT, and/or cheque
 */
export const payoutPhase8Payout = <ThrowOnError extends boolean = false>(
  options: Options<PayoutPhase8PayoutData, ThrowOnError>,
): RequestResult<PayoutPhase8PayoutResponses, PayoutPhase8PayoutErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PayoutPhase8PayoutResponses,
    PayoutPhase8PayoutErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/8-payout',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Discard Draft Payout
 *
 * Discard draft payout before completion
 */
export const payoutDiscard = <ThrowOnError extends boolean = false>(
  options: Options<PayoutDiscardData, ThrowOnError>,
): RequestResult<PayoutDiscardResponses, PayoutDiscardErrors, ThrowOnError> =>
  (options.client ?? client).delete<PayoutDiscardResponses, PayoutDiscardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/discard',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * AuditTrail Draft Payout
 *
 * AuditTrail draft payout before completion
 */
export const payoutAuditTrail = <ThrowOnError extends boolean = false>(
  options: Options<PayoutAuditTrailData, ThrowOnError>,
): RequestResult<PayoutAuditTrailResponses, PayoutAuditTrailErrors, ThrowOnError> =>
  (options.client ?? client).get<PayoutAuditTrailResponses, PayoutAuditTrailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/payout/{payoutId}/audit',
    ...options,
  });

/**
 * List Automated EFT Payments
 *
 * Retrieve the venue's automated EFT payment history, filterable by period, stage (queued, paused, transferring, paid, failed or cancelled) and payout reference.
 */
export const eftAutoPaymentList = <ThrowOnError extends boolean = false>(
  options: Options<EftAutoPaymentListData, ThrowOnError>,
): RequestResult<EftAutoPaymentListResponses, EftAutoPaymentListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    EftAutoPaymentListResponses,
    EftAutoPaymentListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/eft-auto-payment',
    ...options,
  });

/**
 * List Checkd venue users
 *
 * Retrieve paginated list of users for venue
 */
export const ppVenueUserList = <ThrowOnError extends boolean = false>(
  options: Options<PpVenueUserListData, ThrowOnError>,
): RequestResult<PpVenueUserListResponses, PpVenueUserListErrors, ThrowOnError> =>
  (options.client ?? client).get<PpVenueUserListResponses, PpVenueUserListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/users',
    ...options,
  });

/**
 * User Check PIN
 *
 * Check users PIN
 */
export const userPinCheck = <ThrowOnError extends boolean = false>(
  options: Options<UserPinCheckData, ThrowOnError>,
): RequestResult<UserPinCheckResponses, UserPinCheckErrors, ThrowOnError> =>
  (options.client ?? client).put<UserPinCheckResponses, UserPinCheckErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/user/{userId}/pin-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a user association
 *
 * Remove a user from a venue
 */
export const ppVenueUserDelete = <ThrowOnError extends boolean = false>(
  options: Options<PpVenueUserDeleteData, ThrowOnError>,
): RequestResult<PpVenueUserDeleteResponses, PpVenueUserDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    PpVenueUserDeleteResponses,
    PpVenueUserDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/user/{userId}',
    ...options,
  });

/**
 * Get venue user
 *
 * Retrieve paginated list of users for venue
 */
export const ppVenueUserGet = <ThrowOnError extends boolean = false>(
  options: Options<PpVenueUserGetData, ThrowOnError>,
): RequestResult<PpVenueUserGetResponses, PpVenueUserGetErrors, ThrowOnError> =>
  (options.client ?? client).get<PpVenueUserGetResponses, PpVenueUserGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/user/{userId}',
    ...options,
  });

/**
 * Associate a user
 *
 * Associate a user with a Checkd venue
 */
export const ppVenueUserCreate = <ThrowOnError extends boolean = false>(
  options: Options<PpVenueUserCreateData, ThrowOnError>,
): RequestResult<PpVenueUserCreateResponses, PpVenueUserCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PpVenueUserCreateResponses,
    PpVenueUserCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/user/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a user association
 *
 * Update an existing user's association with a checkd venue
 */
export const ppVenueUserUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PpVenueUserUpdateData, ThrowOnError>,
): RequestResult<PpVenueUserUpdateResponses, PpVenueUserUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<PpVenueUserUpdateResponses, PpVenueUserUpdateErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/pp/venue/{venueId}/user/{userId}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    },
  );

/**
 * List risk rule metadata for Checkd venue settings
 *
 * List the risk rules shown in Checkd venue settings.
 */
export const pokieVenueSettingRiskRuleList = <ThrowOnError extends boolean = false>(
  options: Options<PokieVenueSettingRiskRuleListData, ThrowOnError>,
): RequestResult<
  PokieVenueSettingRiskRuleListResponses,
  PokieVenueSettingRiskRuleListErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    PokieVenueSettingRiskRuleListResponses,
    PokieVenueSettingRiskRuleListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/venue-setting/risk-rules',
    ...options,
  });

/**
 * Get Venue Settings for Checkd
 *
 * Get Venue Settings for Checkd
 */
export const pokieVenueSettingGet = <ThrowOnError extends boolean = false>(
  options: Options<PokieVenueSettingGetData, ThrowOnError>,
): RequestResult<PokieVenueSettingGetResponses, PokieVenueSettingGetErrors, ThrowOnError> =>
  (options.client ?? client).get<
    PokieVenueSettingGetResponses,
    PokieVenueSettingGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/venue-setting',
    ...options,
  });

/**
 * Update Venue Payout Settings
 *
 * Update venue-specific settings for payout processing
 */
export const pokieVenueSettingUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PokieVenueSettingUpdateData, ThrowOnError>,
): RequestResult<PokieVenueSettingUpdateResponses, PokieVenueSettingUpdateErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    PokieVenueSettingUpdateResponses,
    PokieVenueSettingUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/venue-setting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Venue VoI Setting
 *
 * Returns the secondary Verification of Identity check configuration for a venue. If no configuration has been saved, a default simple check with no allowed documents is returned.
 */
export const voiSettingGet = <ThrowOnError extends boolean = false>(
  options: Options<VoiSettingGetData, ThrowOnError>,
): RequestResult<VoiSettingGetResponses, VoiSettingGetErrors, ThrowOnError> =>
  (options.client ?? client).get<VoiSettingGetResponses, VoiSettingGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/voi-setting',
    ...options,
  });

/**
 * Update Venue VoI Setting
 *
 * Replaces the secondary VoI check configuration for a venue. The document list is always a full replacement — omitted documents are removed.
 */
export const voiSettingUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VoiSettingUpdateData, ThrowOnError>,
): RequestResult<VoiSettingUpdateResponses, VoiSettingUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<VoiSettingUpdateResponses, VoiSettingUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/voi-setting',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Checkd Dashboard Metrics
 *
 * Get Checkd Dashboard Metrics
 */
export const checkdDashboardMetrics = <ThrowOnError extends boolean = false>(
  options: Options<CheckdDashboardMetricsData, ThrowOnError>,
): RequestResult<CheckdDashboardMetricsResponses, CheckdDashboardMetricsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    CheckdDashboardMetricsResponses,
    CheckdDashboardMetricsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/metrics/dashboard',
    ...options,
  });

/**
 * Get Automated EFT Dashboard Summary
 *
 * Payments due to leave the venue's account within a rolling 24 hours, and the venue's automated EFT exceptions — each counted, with the first five listed.
 */
export const checkdAutoEftDashboard = <ThrowOnError extends boolean = false>(
  options: Options<CheckdAutoEftDashboardData, ThrowOnError>,
): RequestResult<CheckdAutoEftDashboardResponses, CheckdAutoEftDashboardErrors, ThrowOnError> =>
  (options.client ?? client).get<
    CheckdAutoEftDashboardResponses,
    CheckdAutoEftDashboardErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/auto-eft/dashboard',
    ...options,
  });

/**
 * Rank the people at the active venue who resemble a capture
 *
 * Match scanned or typed identity details against the people created at the active venue, most similar first, with how closely each of their details matched.
 */
export const patronSearch = <ThrowOnError extends boolean = false>(
  options: Options<PatronSearchData, ThrowOnError>,
): RequestResult<PatronSearchResponses, PatronSearchErrors, ThrowOnError> =>
  (options.client ?? client).post<PatronSearchResponses, PatronSearchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Compare a capture with a person's recorded details
 *
 * Before a capture is confirmed against a person created at the active venue, list each name, date of birth or phone that both hold and that differs. An offer is audited when any differs. Nothing is written to the person.
 */
export const patronCaptureCompare = <ThrowOnError extends boolean = false>(
  options: Options<PatronCaptureCompareData, ThrowOnError>,
): RequestResult<PatronCaptureCompareResponses, PatronCaptureCompareErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PatronCaptureCompareResponses,
    PatronCaptureCompareErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/capture/compare',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add a capture to an existing person
 *
 * Confirm a capture as a person created at the active venue, adding any detail or document their record lacks. A recorded detail is replaced only by a `detailsDecision` of `updated`, for the ticked details offered by the comparison; a bundle that sends no decision keeps the fill-gaps behaviour.
 */
export const patronCaptureAdd = <ThrowOnError extends boolean = false>(
  options: Options<PatronCaptureAddData, ThrowOnError>,
): RequestResult<PatronCaptureAddResponses, PatronCaptureAddErrors, ThrowOnError> =>
  (options.client ?? client).post<PatronCaptureAddResponses, PatronCaptureAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/capture',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set a person's patron type
 *
 * Record whether a person created at the active venue is a patron, an employee or a contractor.
 */
export const patronTypeUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PatronTypeUpdateData, ThrowOnError>,
): RequestResult<PatronTypeUpdateResponses, PatronTypeUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<PatronTypeUpdateResponses, PatronTypeUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/patron-type',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Correct a person's details
 *
 * Replace the names, date of birth or phone of a person created at the active venue. First name, family name and date of birth cannot be cleared. Each change is audited with masked values. Identity documents are not editable.
 */
export const patronDetailsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<PatronDetailsUpdateData, ThrowOnError>,
): RequestResult<PatronDetailsUpdateResponses, PatronDetailsUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    PatronDetailsUpdateResponses,
    PatronDetailsUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/details',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read a person's audit trail
 *
 * What happened to and with a person created at the active venue, newest first, read from the audit sink one page at a time. Changed values are masked.
 */
export const patronAuditTrail = <ThrowOnError extends boolean = false>(
  options: Options<PatronAuditTrailData, ThrowOnError>,
): RequestResult<PatronAuditTrailResponses, PatronAuditTrailErrors, ThrowOnError> =>
  (options.client ?? client).get<PatronAuditTrailResponses, PatronAuditTrailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/audit',
    ...options,
  });

/**
 * Decide the result of a PEP, sanctions and adverse media check
 *
 * Confirm which of a check's candidates the person is, or that none of them is. Only the person's newest check can be decided, and only once.
 */
export const patronPepCheckDecide = <ThrowOnError extends boolean = false>(
  options: Options<PatronPepCheckDecideData, ThrowOnError>,
): RequestResult<PatronPepCheckDecideResponses, PatronPepCheckDecideErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PatronPepCheckDecideResponses,
    PatronPepCheckDecideErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/pep-check/{checkId}/decision',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Run a PEP, sanctions and adverse media check on a person
 *
 * Screen a person created at the active venue against the provider now, outside any payout. Always a fresh provider call.
 */
export const patronPepCheckRun = <ThrowOnError extends boolean = false>(
  options: Options<PatronPepCheckRunData, ThrowOnError>,
): RequestResult<PatronPepCheckRunResponses, PatronPepCheckRunErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PatronPepCheckRunResponses,
    PatronPepCheckRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/pep-check',
    ...options,
  });

/**
 * Verify a scan of a person's ID with DVS
 *
 * Check a freshly scanned ID of a person created at the active venue with the issuing authority, outside any payout. The scan's names and date of birth must be the person's.
 */
export const patronDvsCheckRun = <ThrowOnError extends boolean = false>(
  options: Options<PatronDvsCheckRunData, ThrowOnError>,
): RequestResult<PatronDvsCheckRunResponses, PatronDvsCheckRunErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PatronDvsCheckRunResponses,
    PatronDvsCheckRunErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/dvs-check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Verify a person's digital licence
 *
 * Verify a QLD or VIC digital licence of a person created at the active venue, and record it as their identity check. The licence's name and date of birth must be the person's.
 */
export const patronIdentityCheckDigital = <ThrowOnError extends boolean = false>(
  options: Options<PatronIdentityCheckDigitalData, ThrowOnError>,
): RequestResult<
  PatronIdentityCheckDigitalResponses,
  PatronIdentityCheckDigitalErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PatronIdentityCheckDigitalResponses,
    PatronIdentityCheckDigitalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/identity-check/digital',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Attach a Check a Person digital licence check to the person recorded
 *
 * Attach the caller's own Check a Person digital licence check, scanned within the last 15 minutes, to the person it names. A check is attached once.
 */
export const patronIdentityCheckAttach = <ThrowOnError extends boolean = false>(
  options: Options<PatronIdentityCheckAttachData, ThrowOnError>,
): RequestResult<
  PatronIdentityCheckAttachResponses,
  PatronIdentityCheckAttachErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    PatronIdentityCheckAttachResponses,
    PatronIdentityCheckAttachErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}/identity-check/{identityCheckId}/attach',
    ...options,
  });

/**
 * Verify a digital licence on Check a Person
 *
 * Verify a QLD or VIC digital licence before the person is recorded. The check is held for the scanning user to attach to the person they record, within 15 minutes.
 */
export const adhocIdentityCheckDigital = <ThrowOnError extends boolean = false>(
  options: Options<AdhocIdentityCheckDigitalData, ThrowOnError>,
): RequestResult<
  AdhocIdentityCheckDigitalResponses,
  AdhocIdentityCheckDigitalErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdhocIdentityCheckDigitalResponses,
    AdhocIdentityCheckDigitalErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/identity-check/digital',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a person with their screening history
 *
 * Retrieve one person created at the active venue, with the verdict standing against them and every screening check run against them.
 */
export const patronGet = <ThrowOnError extends boolean = false>(
  options: Options<PatronGetData, ThrowOnError>,
): RequestResult<PatronGetResponses, PatronGetErrors, ThrowOnError> =>
  (options.client ?? client).get<PatronGetResponses, PatronGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron/{patronId}',
    ...options,
  });

/**
 * List people known to the venue
 *
 * Retrieve paginated people created at the active venue, each with the screening verdict currently standing against them.
 */
export const patronList = <ThrowOnError extends boolean = false>(
  options: Options<PatronListData, ThrowOnError>,
): RequestResult<PatronListResponses, PatronListErrors, ThrowOnError> =>
  (options.client ?? client).get<PatronListResponses, PatronListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron',
    ...options,
  });

/**
 * Record a new person at the active venue
 *
 * Create a person from captured identity details, with their document when one was captured.
 */
export const patronCreate = <ThrowOnError extends boolean = false>(
  options: Options<PatronCreateData, ThrowOnError>,
): RequestResult<PatronCreateResponses, PatronCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<PatronCreateResponses, PatronCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/patron',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get AML risk register metrics
 *
 * Get AML risk register metrics for the active venue.
 */
export const riskRegisterMetrics = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterMetricsData, ThrowOnError>,
): RequestResult<RiskRegisterMetricsResponses, RiskRegisterMetricsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    RiskRegisterMetricsResponses,
    RiskRegisterMetricsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register/metrics',
    ...options,
  });

/**
 * Search patrons for a manual AML risk
 *
 * Name search over the venue's patrons, to associate a manual risk with an existing patron.
 */
export const riskRegisterPatronSearch = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterPatronSearchData, ThrowOnError>,
): RequestResult<RiskRegisterPatronSearchResponses, RiskRegisterPatronSearchErrors, ThrowOnError> =>
  (options.client ?? client).get<
    RiskRegisterPatronSearchResponses,
    RiskRegisterPatronSearchErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register/patron-search',
    ...options,
  });

/**
 * Search payouts to link to a manual AML risk
 *
 * Search the venue's payouts by external id, patron name, or a whole-dollar amount that starts with the query.
 */
export const riskRegisterPayoutSearch = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterPayoutSearchData, ThrowOnError>,
): RequestResult<RiskRegisterPayoutSearchResponses, RiskRegisterPayoutSearchErrors, ThrowOnError> =>
  (options.client ?? client).get<
    RiskRegisterPayoutSearchResponses,
    RiskRegisterPayoutSearchErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register/payout-search',
    ...options,
  });

/**
 * Review an AML risk register item
 *
 * Persist a manager AML risk review decision for a risk register entry.
 */
export const riskRegisterReview = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterReviewData, ThrowOnError>,
): RequestResult<RiskRegisterReviewResponses, RiskRegisterReviewErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RiskRegisterReviewResponses,
    RiskRegisterReviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register/entry/{entryId}/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a supporting document from a risk register item
 *
 * Delete a supporting document attached to a payout risk register item.
 */
export const riskRegisterAttachmentDelete = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterAttachmentDeleteData, ThrowOnError>,
): RequestResult<
  RiskRegisterAttachmentDeleteResponses,
  RiskRegisterAttachmentDeleteErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    RiskRegisterAttachmentDeleteResponses,
    RiskRegisterAttachmentDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register/entry/{entryId}/documents',
    ...options,
  });

/**
 * List supporting documents for a risk register item
 *
 * Retrieve the supporting documents attached to a payout risk register item.
 */
export const riskRegisterAttachmentGet = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterAttachmentGetData, ThrowOnError>,
): RequestResult<
  RiskRegisterAttachmentGetResponses,
  RiskRegisterAttachmentGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    RiskRegisterAttachmentGetResponses,
    RiskRegisterAttachmentGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register/entry/{entryId}/documents',
    ...options,
  });

/**
 * Attach a supporting document to a risk register item
 *
 * Associate an uploaded file with a payout risk register item as a supporting document. Available both during and after the manager review.
 */
export const riskRegisterAttachmentCreate = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterAttachmentCreateData, ThrowOnError>,
): RequestResult<
  RiskRegisterAttachmentCreateResponses,
  RiskRegisterAttachmentCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    RiskRegisterAttachmentCreateResponses,
    RiskRegisterAttachmentCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register/entry/{entryId}/documents',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List AML risk register items
 *
 * Retrieve paginated AML risk register items for the active venue.
 */
export const riskRegisterList = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterListData, ThrowOnError>,
): RequestResult<RiskRegisterListResponses, RiskRegisterListErrors, ThrowOnError> =>
  (options.client ?? client).get<RiskRegisterListResponses, RiskRegisterListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register',
    ...options,
  });

/**
 * Create a manual AML risk register entry
 *
 * Register a manually-identified AML risk. Optionally include a review payload to action it in the same request; otherwise it is registered as awaiting review.
 */
export const riskRegisterCreate = <ThrowOnError extends boolean = false>(
  options: Options<RiskRegisterCreateData, ThrowOnError>,
): RequestResult<RiskRegisterCreateResponses, RiskRegisterCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    RiskRegisterCreateResponses,
    RiskRegisterCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/risk-register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Checkd application invitation
 *
 * Invite a user by email to join the venue with a specific role for checkd application
 */
export const ppUserInvite = <ThrowOnError extends boolean = false>(
  options: Options<PpUserInviteData, ThrowOnError>,
): RequestResult<PpUserInviteResponses, PpUserInviteErrors, ThrowOnError> =>
  (options.client ?? client).post<PpUserInviteResponses, PpUserInviteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Checkd application reinvitation
 *
 * Reinvite a user by email to join the venue with a specific role for checkd application
 */
export const ppUserReinvite = <ThrowOnError extends boolean = false>(
  options: Options<PpUserReinviteData, ThrowOnError>,
): RequestResult<PpUserReinviteResponses, PpUserReinviteErrors, ThrowOnError> =>
  (options.client ?? client).post<PpUserReinviteResponses, PpUserReinviteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/user/{userId}/reinvite',
    ...options,
  });

/**
 * Checkd application revoke invitation
 *
 * Revoke a user invite to join the venue with a specific role for checkd application
 */
export const ppUserRevokeInvite = <ThrowOnError extends boolean = false>(
  options: Options<PpUserRevokeInviteData, ThrowOnError>,
): RequestResult<PpUserRevokeInviteResponses, PpUserRevokeInviteErrors, ThrowOnError> =>
  (options.client ?? client).post<
    PpUserRevokeInviteResponses,
    PpUserRevokeInviteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/user/{userId}/revoke-invite',
    ...options,
  });

/**
 * List Permission Catalogue
 *
 * The application’s declared permissions with their titles. Venue-membership gated on purpose (contract, api-surface.md): the catalogue is static capability names, carrying no venue or user data
 */
export const permissionCatalogueList = <ThrowOnError extends boolean = false>(
  options: Options<PermissionCatalogueListData, ThrowOnError>,
): RequestResult<PermissionCatalogueListResponses, PermissionCatalogueListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    PermissionCatalogueListResponses,
    PermissionCatalogueListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/permission',
    ...options,
  });

/**
 * List the venue-application's roles
 *
 * Every role that exists at this venue and application, with its help text, for the surfaces that offer a role. There is no offered or hidden state — a role exists or it was deleted.
 */
export const venueAssignableRoleList = <ThrowOnError extends boolean = false>(
  options: Options<VenueAssignableRoleListData, ThrowOnError>,
): RequestResult<VenueAssignableRoleListResponses, VenueAssignableRoleListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    VenueAssignableRoleListResponses,
    VenueAssignableRoleListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/assignable-role',
    ...options,
  });

/**
 * Update Venue Role Permissions
 *
 * Save the permissions of several roles at once, as the roles grid does. Applied in one transaction, so a refusal on any role leaves every role unchanged
 */
export const venueRolePermissionsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VenueRolePermissionsUpdateData, ThrowOnError>,
): RequestResult<
  VenueRolePermissionsUpdateResponses,
  VenueRolePermissionsUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    VenueRolePermissionsUpdateResponses,
    VenueRolePermissionsUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/role-permissions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Venue Roles
 *
 * Every role that exists at the caller's venue-application, with its permissions, help text and holder count
 */
export const venueRoleList = <ThrowOnError extends boolean = false>(
  options: Options<VenueRoleListData, ThrowOnError>,
): RequestResult<VenueRoleListResponses, VenueRoleListErrors, ThrowOnError> =>
  (options.client ?? client).get<VenueRoleListResponses, VenueRoleListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/role',
    ...options,
  });

/**
 * Create Venue Role
 *
 * Create a role at the caller’s venue-application. There is no grant ceiling: any catalogue permission may be granted (FR-014)
 */
export const venueRoleCreate = <ThrowOnError extends boolean = false>(
  options: Options<VenueRoleCreateData, ThrowOnError>,
): RequestResult<VenueRoleCreateResponses, VenueRoleCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<VenueRoleCreateResponses, VenueRoleCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/role',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Venue Role
 *
 * Delete a role nobody holds. A held role is refused, stating the count (FR-018)
 */
export const venueRoleDelete = <ThrowOnError extends boolean = false>(
  options: Options<VenueRoleDeleteData, ThrowOnError>,
): RequestResult<VenueRoleDeleteResponses, VenueRoleDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<VenueRoleDeleteResponses, VenueRoleDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/role/{roleId}',
    ...options,
  });

/**
 * Get Venue Role
 *
 * One role of the caller’s venue-application, with its permissions and holders
 */
export const venueRoleGet = <ThrowOnError extends boolean = false>(
  options: Options<VenueRoleGetData, ThrowOnError>,
): RequestResult<VenueRoleGetResponses, VenueRoleGetErrors, ThrowOnError> =>
  (options.client ?? client).get<VenueRoleGetResponses, VenueRoleGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/role/{roleId}',
    ...options,
  });

/**
 * Update Venue Role
 *
 * Rename a role, reword its help text, or change the permissions it grants
 */
export const venueRoleUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VenueRoleUpdateData, ThrowOnError>,
): RequestResult<VenueRoleUpdateResponses, VenueRoleUpdateErrors, ThrowOnError> =>
  (options.client ?? client).patch<VenueRoleUpdateResponses, VenueRoleUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/pp/venue/{venueId}/role/{roleId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Automated EFT metrics, exception cohorts and sweep health across every venue
 *
 * iDU-admin-only, any venue. Aggregate volumes and success/failure rates for a period, failures broken down by reason with an explicit reason_not_reported bucket, counts for every exception cohort, sweep health separating a missed sweep from a quiet period and from venue ineligibility, and the paginated drill-through behind an aggregate figure. The period is matched on eligibleAt, so a failure that never reached submission is counted.
 */
export const iduAutoEftMetrics = <ThrowOnError extends boolean = false>(
  options: Options<IduAutoEftMetricsData, ThrowOnError>,
): RequestResult<IduAutoEftMetricsResponses, IduAutoEftMetricsErrors, ThrowOnError> =>
  (options.client ?? client).get<IduAutoEftMetricsResponses, IduAutoEftMetricsErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/idu/auto-eft/metrics',
      ...options,
    },
  );

/**
 * Browse every automated EFT payment across the estate
 *
 * iDU-admin-only, any venue, read-only. Lists automated EFT payments in every state — not only exceptions — with optional filters on status, cohort, venue and payout reference. No period is required and none is applied: the estate is browsed in full. Every row reports the cohort it classifies into, so a record can be read without filtering by cohort. A cohort filter cannot be expressed in SQL, so those requests are classified over a bounded scan and paginated afterwards; `scan.truncated` reports when the scan hit its cap.
 */
export const iduAutoEftRecords = <ThrowOnError extends boolean = false>(
  options?: Options<IduAutoEftRecordsData, ThrowOnError>,
): RequestResult<IduAutoEftRecordsResponses, IduAutoEftRecordsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduAutoEftRecordsResponses,
    IduAutoEftRecordsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/auto-eft/records',
    ...options,
  });

/**
 * Check an automated EFT payment against Merchant Warrior
 *
 * iDU-admin-only, any venue. Asks the venue’s own Merchant Warrior account whether it holds a payout batch for this payment, so staff can confirm no money moved before deciding whether to pay again. Read-only: nothing is written, retried or repaired. The identifier asked under is reported — Merchant Warrior’s payout id, the stored submission reference, or the deterministic reference the payment would have carried, in that order — so a record that died before storing anything is still answerable. `no_batch_found` is the assurance that nothing was submitted; `unconfirmed` means Merchant Warrior could not be asked and is explicitly NOT that assurance.
 */
export const iduAutoEftMerchantWarriorCheck = <ThrowOnError extends boolean = false>(
  options: Options<IduAutoEftMerchantWarriorCheckData, ThrowOnError>,
): RequestResult<
  IduAutoEftMerchantWarriorCheckResponses,
  IduAutoEftMerchantWarriorCheckErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IduAutoEftMerchantWarriorCheckResponses,
    IduAutoEftMerchantWarriorCheckErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/auto-eft/records/{recordId}/merchant-warrior-check',
    ...options,
  });

/**
 * Record a staff resolution for an automated EFT payment
 *
 * iDU-admin-only, any venue. Records that iDU or Merchant Warrior resolved a failed or stuck automated EFT payment, so the venue-facing view shows it as resolved. The record keeps its status and its full failure history: the resolution is appended to the audit trail and the only column written is the marker the venue-facing view reads. Refused for any other status, including paid, and refused a second time for an already-resolved record.
 */
export const iduAutoEftResolutionRecord = <ThrowOnError extends boolean = false>(
  options: Options<IduAutoEftResolutionRecordData, ThrowOnError>,
): RequestResult<
  IduAutoEftResolutionRecordResponses,
  IduAutoEftResolutionRecordErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IduAutoEftResolutionRecordResponses,
    IduAutoEftResolutionRecordErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/auto-eft/resolutions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Mark an automated EFT payment retryable, for any venue
 *
 * iDU-admin-only, any venue. Returns a payment_failed record to scheduled so the next sweep can pick it up — the same service call Checkd managers make for their own venue, at a wider reach. The venue is read from the record, never supplied by the caller. Refused for any status other than payment_failed.
 */
export const iduAutoEftRetryable = <ThrowOnError extends boolean = false>(
  options: Options<IduAutoEftRetryableData, ThrowOnError>,
): RequestResult<IduAutoEftRetryableResponses, IduAutoEftRetryableErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduAutoEftRetryableResponses,
    IduAutoEftRetryableErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/auto-eft/retryable',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get dashboard metrics for Checkd
 *
 * Get top venues sorted by longest time since last payout (admin dashboard)
 */
export const iduDashboardMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<IduDashboardMetricsData, ThrowOnError>,
): RequestResult<IduDashboardMetricsResponses, IduDashboardMetricsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduDashboardMetricsResponses,
    IduDashboardMetricsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/metrics/dashboard',
    ...options,
  });

/**
 * Get global Checkd metrics for the admin dashboard
 *
 * Grand totals (all-time, plus last-30d per metric with 30d / 90d / all-time change indicators), aggregate payout stats over finalised payouts, payments split by tender type, and risk breakdown by suggested and manager risk level.
 */
export const iduDashboardCheckdMetrics = <ThrowOnError extends boolean = false>(
  options?: Options<IduDashboardCheckdMetricsData, ThrowOnError>,
): RequestResult<
  IduDashboardCheckdMetricsResponses,
  IduDashboardCheckdMetricsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    IduDashboardCheckdMetricsResponses,
    IduDashboardCheckdMetricsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/metrics/checkd',
    ...options,
  });

/**
 * Get Checkd venue league tables for the admin dashboard
 *
 * Top 10 venues with declining product usage and top 10 with the most discarded/rejected payouts, each with a 12-month sparkline.
 */
export const iduDashboardCheckdVenueTables = <ThrowOnError extends boolean = false>(
  options?: Options<IduDashboardCheckdVenueTablesData, ThrowOnError>,
): RequestResult<
  IduDashboardCheckdVenueTablesResponses,
  IduDashboardCheckdVenueTablesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    IduDashboardCheckdVenueTablesResponses,
    IduDashboardCheckdVenueTablesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/metrics/checkd/venues',
    ...options,
  });

/**
 * Get per-venue Checkd metrics for the admin dashboard
 *
 * Usage/value/experience metrics for a single venue: payout windows (30/90/all + all-venue average), stage timings, risk breakdown, confirmed BNDRY matches by category, hour-of-day distribution, and Confirmation of Payee coverage/outcomes.
 */
export const iduDashboardCheckdVenueMetrics = <ThrowOnError extends boolean = false>(
  options: Options<IduDashboardCheckdVenueMetricsData, ThrowOnError>,
): RequestResult<
  IduDashboardCheckdVenueMetricsResponses,
  IduDashboardCheckdVenueMetricsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IduDashboardCheckdVenueMetricsResponses,
    IduDashboardCheckdVenueMetricsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/metrics/venue/{venueId}/checkd',
    ...options,
  });

/**
 * List Checkd payouts for metric drill-downs
 *
 * Paginated payout list filtered by risk (suggested/manager level), venue, status, and Confirmation of Payee result. Used by the risk-breakdown and Confirmation of Payee drill-down links. Admin-only; excludes patron PII.
 */
export const iduDashboardCheckdPayoutList = <ThrowOnError extends boolean = false>(
  options?: Options<IduDashboardCheckdPayoutListData, ThrowOnError>,
): RequestResult<
  IduDashboardCheckdPayoutListResponses,
  IduDashboardCheckdPayoutListErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    IduDashboardCheckdPayoutListResponses,
    IduDashboardCheckdPayoutListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/metrics/payouts/list',
    ...options,
  });

/**
 * Preview moving a payout to another venue
 *
 * Reports what moving this payout would change — the reference it would take at the destination, what happens to the patron record, and anything that blocks the move. Read-only. Admin dashboard only.
 */
export const iduPayoutVenueMovePreview = <ThrowOnError extends boolean = false>(
  options: Options<IduPayoutVenueMovePreviewData, ThrowOnError>,
): RequestResult<
  IduPayoutVenueMovePreviewResponses,
  IduPayoutVenueMovePreviewErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IduPayoutVenueMovePreviewResponses,
    IduPayoutVenueMovePreviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/payouts/{payoutId}/venue-move',
    ...options,
  });

/**
 * Move a payout to another venue
 *
 * Moves a payout raised against the wrong venue. Re-allocates the payout's reference number at the destination, re-points its risk-register and confirmation-of-payee rows, and moves or copies the patron record so the destination can still match them. Admin dashboard only.
 */
export const iduPayoutVenueMove = <ThrowOnError extends boolean = false>(
  options: Options<IduPayoutVenueMoveData, ThrowOnError>,
): RequestResult<IduPayoutVenueMoveResponses, IduPayoutVenueMoveErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduPayoutVenueMoveResponses,
    IduPayoutVenueMoveErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/payouts/{payoutId}/venue-move',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Payout audit trail
 *
 * The payout's audit trail, in the same shape Checkd renders — so customer success sees the correction history where the correction is made. Admin dashboard only.
 */
export const iduPayoutAudit = <ThrowOnError extends boolean = false>(
  options: Options<IduPayoutAuditData, ThrowOnError>,
): RequestResult<IduPayoutAuditResponses, IduPayoutAuditErrors, ThrowOnError> =>
  (options.client ?? client).get<IduPayoutAuditResponses, IduPayoutAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/payouts/{payoutId}/audit',
    ...options,
  });

/**
 * Preview a customer-success payout correction
 *
 * Reports what applying the proposed changes would do — anything that blocks the correction, the downstream effects it would trigger, and a before/after diff. Read-only: nothing is written and nothing is logged. Admin dashboard only.
 */
export const iduPayoutCorrectionPreview = <ThrowOnError extends boolean = false>(
  options: Options<IduPayoutCorrectionPreviewData, ThrowOnError>,
): RequestResult<
  IduPayoutCorrectionPreviewResponses,
  IduPayoutCorrectionPreviewErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IduPayoutCorrectionPreviewResponses,
    IduPayoutCorrectionPreviewErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/payouts/{payoutId}/correction/preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Correct a payout on behalf of a venue
 *
 * Applies a customer-success correction to the payment split, patron name or patron banking detail fields. Banking details are refused once the automated EFT payment is in flight or has paid. Re-evaluates the preview rules, refuses when the payout changed since it was loaded, and records the correction with its reason in the audit trail. Admin dashboard only.
 */
export const iduPayoutCorrection = <ThrowOnError extends boolean = false>(
  options: Options<IduPayoutCorrectionData, ThrowOnError>,
): RequestResult<IduPayoutCorrectionResponses, IduPayoutCorrectionErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduPayoutCorrectionResponses,
    IduPayoutCorrectionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/payouts/{payoutId}/correction',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Payout detail with correctability
 *
 * Returns a payout with its patron name fields and what a customer-success correction may change on it. The updatedAt is echoed back on the correction endpoint for conflict detection. Admin dashboard only.
 */
export const iduPayoutDetail = <ThrowOnError extends boolean = false>(
  options: Options<IduPayoutDetailData, ThrowOnError>,
): RequestResult<IduPayoutDetailResponses, IduPayoutDetailErrors, ThrowOnError> =>
  (options.client ?? client).get<IduPayoutDetailResponses, IduPayoutDetailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/payouts/{payoutId}',
    ...options,
  });

/**
 * List logs
 *
 * List frontend and backend log entries for the admin dashboard.
 */
export const iduLogsList = <ThrowOnError extends boolean = false>(
  options?: Options<IduLogsListData, ThrowOnError>,
): RequestResult<IduLogsListResponses, IduLogsListErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduLogsListResponses, IduLogsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/logs',
    ...options,
  });

/**
 * List venues
 *
 * List all venues (admin dashboard only)
 */
export const iduVenueList = <ThrowOnError extends boolean = false>(
  options?: Options<IduVenueListData, ThrowOnError>,
): RequestResult<IduVenueListResponses, IduVenueListErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduVenueListResponses, IduVenueListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues',
    ...options,
  });

/**
 * Create a venue
 *
 * Create a new venue (admin dashboard only)
 */
export const iduVenueCreate = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueCreateData, ThrowOnError>,
): RequestResult<IduVenueCreateResponses, IduVenueCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<IduVenueCreateResponses, IduVenueCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get venue details
 *
 * Get a single venue (admin dashboard only)
 */
export const iduVenueGet = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueGetData, ThrowOnError>,
): RequestResult<IduVenueGetResponses, IduVenueGetErrors, ThrowOnError> =>
  (options.client ?? client).get<IduVenueGetResponses, IduVenueGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}',
    ...options,
  });

/**
 * Update venue
 *
 * Update venue details (admin dashboard only)
 */
export const iduVenueUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueUpdateData, ThrowOnError>,
): RequestResult<IduVenueUpdateResponses, IduVenueUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<IduVenueUpdateResponses, IduVenueUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Query CS admin audit trail
 *
 * Query the CS admin audit trail (projected from the immutable GCP audit sink) by actor/entity/venue/action/date-range.
 */
export const iduAuditList = <ThrowOnError extends boolean = false>(
  options?: Options<IduAuditListData, ThrowOnError>,
): RequestResult<IduAuditListResponses, IduAuditListErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduAuditListResponses, IduAuditListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/audit',
    ...options,
  });

/**
 * List users for a venue
 *
 * List users for a given venue + application (admin dashboard only)
 */
export const iduVenueUsersList = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueUsersListData, ThrowOnError>,
): RequestResult<IduVenueUsersListResponses, IduVenueUsersListErrors, ThrowOnError> =>
  (options.client ?? client).get<IduVenueUsersListResponses, IduVenueUsersListErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/idu/venues/{targetVenueId}/users',
      ...options,
    },
  );

/**
 * List a venue-application's roles
 *
 * The target venue-application's roles with help text (admin dashboard only)
 */
export const iduVenueRolesList = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueRolesListData, ThrowOnError>,
): RequestResult<IduVenueRolesListResponses, IduVenueRolesListErrors, ThrowOnError> =>
  (options.client ?? client).get<IduVenueRolesListResponses, IduVenueRolesListErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/api/v1/idu/venues/{targetVenueId}/roles',
      ...options,
    },
  );

/**
 * Get Checkd venue settings
 *
 * Get a venue’s Checkd (pokie payout) settings, including internally-managed fields (venue lat/long for the distance risk rule, ConnectID availability) that Checkd itself cannot write (admin dashboard only)
 */
export const iduCheckdVenueSettingGet = <ThrowOnError extends boolean = false>(
  options: Options<IduCheckdVenueSettingGetData, ThrowOnError>,
): RequestResult<IduCheckdVenueSettingGetResponses, IduCheckdVenueSettingGetErrors, ThrowOnError> =>
  (options.client ?? client).get<
    IduCheckdVenueSettingGetResponses,
    IduCheckdVenueSettingGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/checkd-settings',
    ...options,
  });

/**
 * Update Checkd venue settings
 *
 * Update a venue's Checkd (pokie payout) settings, including internally-managed fields (venue lat/long for the distance risk rule, ConnectID availability) that Checkd itself cannot write (admin dashboard only)
 */
export const iduCheckdVenueSettingUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduCheckdVenueSettingUpdateData, ThrowOnError>,
): RequestResult<
  IduCheckdVenueSettingUpdateResponses,
  IduCheckdVenueSettingUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    IduCheckdVenueSettingUpdateResponses,
    IduCheckdVenueSettingUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/checkd-settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Record a venue's Merchant Warrior payout credentials
 *
 * Writes the three values into this venue’s entry in the shared credential secret, replacing any previous entry (rotation) and carrying every other venue’s entry forward unchanged. The response body carries nothing about what was written — no echo, no masked preview (FR-002) — which is why this is its own endpoint rather than a Checkd venue-settings field.
 */
export const iduVenueMwCredentialsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueMwCredentialsUpdateData, ThrowOnError>,
): RequestResult<
  IduVenueMwCredentialsUpdateResponses,
  IduVenueMwCredentialsUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    IduVenueMwCredentialsUpdateResponses,
    IduVenueMwCredentialsUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/mw-credentials',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Whether a venue has Merchant Warrior credentials, and when they were last written
 *
 * Existence and last-written only (FR-003) — never any part of a value. The retrieval path also returns the secret version this venue’s entry was read from; that is an internal write-concurrency token and is deliberately not projected here.
 */
export const iduVenueMwCredentialsStatus = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueMwCredentialsStatusData, ThrowOnError>,
): RequestResult<
  IduVenueMwCredentialsStatusResponses,
  IduVenueMwCredentialsStatusErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IduVenueMwCredentialsStatusResponses,
    IduVenueMwCredentialsStatusErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/mw-credentials/status',
    ...options,
  });

/**
 * Summary
 *
 * Description
 */
export const iduVenueApplicationAssign = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueApplicationAssignData, ThrowOnError>,
): RequestResult<
  IduVenueApplicationAssignResponses,
  IduVenueApplicationAssignErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    IduVenueApplicationAssignResponses,
    IduVenueApplicationAssignErrors,
    ThrowOnError
  >({
    url: '/api/v1/idu/venues/{venueId}/applications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Summary
 *
 * Description
 */
export const iduVenueApplicationRemove = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueApplicationRemoveData, ThrowOnError>,
): RequestResult<
  IduVenueApplicationRemoveResponses,
  IduVenueApplicationRemoveErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    IduVenueApplicationRemoveResponses,
    IduVenueApplicationRemoveErrors,
    ThrowOnError
  >({ url: '/api/v1/idu/venues/{venueId}/applications/{application}', ...options });

/**
 * List nightlife venues, a page at a time
 *
 * The application's nightlife venues beside their web-apps links (linked, unlinked, or linked but needing a HubSpot id), 200 at most a page, of one customer status when given. Pass each nextCursor back as cursor until it is null; search what has been read.
 */
export const iduNightlifeVenueList = <ThrowOnError extends boolean = false>(
  options: Options<IduNightlifeVenueListData, ThrowOnError>,
): RequestResult<IduNightlifeVenueListResponses, IduNightlifeVenueListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    IduNightlifeVenueListResponses,
    IduNightlifeVenueListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/nightlife/{application}/venues',
    ...options,
  });

/**
 * Create a venue for a nightlife venue
 *
 * Creates a web-apps venue from the nightlife venue and links the two, without matching on HubSpot id (link to an existing venue with link-to). The new venue takes the nightlife venue's HubSpot company id. Enables the application on the venue and writes webappsVenueId to the nightlife document. Repeating it on a linked nightlife venue re-writes the document.
 */
export const iduNightlifeVenueLink = <ThrowOnError extends boolean = false>(
  options: Options<IduNightlifeVenueLinkData, ThrowOnError>,
): RequestResult<IduNightlifeVenueLinkResponses, IduNightlifeVenueLinkErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduNightlifeVenueLinkResponses,
    IduNightlifeVenueLinkErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/nightlife/{application}/venues/{firestoreVenueId}/link',
    ...options,
  });

/**
 * Link a nightlife venue to a chosen venue
 *
 * Links an unlinked nightlife venue to the web-apps venue staff chose, e.g. after an ambiguous HubSpot match. 409 when either side is already linked in the application.
 */
export const iduNightlifeVenueLinkTo = <ThrowOnError extends boolean = false>(
  options: Options<IduNightlifeVenueLinkToData, ThrowOnError>,
): RequestResult<IduNightlifeVenueLinkToResponses, IduNightlifeVenueLinkToErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduNightlifeVenueLinkToResponses,
    IduNightlifeVenueLinkToErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/nightlife/{application}/venues/{firestoreVenueId}/link-to',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Relink a nightlife venue
 *
 * Moves a nightlife venue's link to another web-apps venue, with the previous venue's grants and pending invites for the application. Nightlife access does not change. The previous venue's application is turned off.
 */
export const iduNightlifeVenueRelink = <ThrowOnError extends boolean = false>(
  options: Options<IduNightlifeVenueRelinkData, ThrowOnError>,
): RequestResult<IduNightlifeVenueRelinkResponses, IduNightlifeVenueRelinkErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduNightlifeVenueRelinkResponses,
    IduNightlifeVenueRelinkErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/nightlife/{application}/venues/{firestoreVenueId}/relink',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * A venue's nightlife links
 *
 * For each nightlife application: whether this environment reaches its nightlife API, and the nightlife venue the web-apps venue is linked to, if any.
 */
export const iduVenueNightlifeLinks = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueNightlifeLinksData, ThrowOnError>,
): RequestResult<IduVenueNightlifeLinksResponses, IduVenueNightlifeLinksErrors, ThrowOnError> =>
  (options.client ?? client).get<
    IduVenueNightlifeLinksResponses,
    IduVenueNightlifeLinksErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/nightlife',
    ...options,
  });

/**
 * Create a nightlife venue for a venue
 *
 * Creates the nightlife venue document for this web-apps venue (its name, status and HubSpot id come from the venue), links it and enables the application. 409 when the venue is already linked, or SITE_NUMBER_TAKEN / SITE_NUMBER_SHARED from nightlife. The venue's address is rewritten from the structured address.
 */
export const iduVenueNightlifeCreate = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueNightlifeCreateData, ThrowOnError>,
): RequestResult<IduVenueNightlifeCreateResponses, IduVenueNightlifeCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduVenueNightlifeCreateResponses,
    IduVenueNightlifeCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/nightlife/{application}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * A venue's nightlife settings
 *
 * The linked nightlife venue document, read through the internal nightlife API.
 */
export const iduVenueNightlifeSettingsGet = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueNightlifeSettingsGetData, ThrowOnError>,
): RequestResult<
  IduVenueNightlifeSettingsGetResponses,
  IduVenueNightlifeSettingsGetErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IduVenueNightlifeSettingsGetResponses,
    IduVenueNightlifeSettingsGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/nightlife/{application}/settings',
    ...options,
  });

/**
 * Update a venue's nightlife settings
 *
 * Writes the given nightlife-only fields to the linked nightlife venue; `settings` sections merge into the stored ones. Name, status and HubSpot id are the web-apps venue's and are not accepted here. Changing the structured address also rewrites the venue's address.
 */
export const iduVenueNightlifeSettingsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueNightlifeSettingsUpdateData, ThrowOnError>,
): RequestResult<
  IduVenueNightlifeSettingsUpdateResponses,
  IduVenueNightlifeSettingsUpdateErrors,
  ThrowOnError
> =>
  (options.client ?? client).patch<
    IduVenueNightlifeSettingsUpdateResponses,
    IduVenueNightlifeSettingsUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/nightlife/{application}/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * A venue's unmoved nightlife managers
 *
 * Managers at the linked nightlife venue still on an old iDU login that has not moved to its own account.
 */
export const iduVenueNightlifeLegacyManagers = <ThrowOnError extends boolean = false>(
  options: Options<IduVenueNightlifeLegacyManagersData, ThrowOnError>,
): RequestResult<
  IduVenueNightlifeLegacyManagersResponses,
  IduVenueNightlifeLegacyManagersErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    IduVenueNightlifeLegacyManagersResponses,
    IduVenueNightlifeLegacyManagersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/nightlife/{application}/legacy-managers',
    ...options,
  });

/**
 * KYC Dashboard
 *
 * Get metrics for KYC (admin dashboard only)
 */
export const iduKycDashboard = <ThrowOnError extends boolean = false>(
  options?: Options<IduKycDashboardData, ThrowOnError>,
): RequestResult<IduKycDashboardResponses, IduKycDashboardErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduKycDashboardResponses, IduKycDashboardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/kyc-dashboard',
    ...options,
  });

/**
 * List PEP check activity
 *
 * Paginated list of PEP (BNDRY) checks with venue, payout, trigger reason, reuse and outcome, for admin traceability/investigation (admin dashboard only)
 */
export const iduPepCheckActivityList = <ThrowOnError extends boolean = false>(
  options?: Options<IduPepCheckActivityListData, ThrowOnError>,
): RequestResult<IduPepCheckActivityListResponses, IduPepCheckActivityListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduPepCheckActivityListResponses,
    IduPepCheckActivityListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/pep-check-activity',
    ...options,
  });

/**
 * PEP check run stats
 *
 * Fresh vs. reused BNDRY PEP check counts for a period, to spot wasted re-checks / BNDRY spend (admin dashboard only)
 */
export const iduPepCheckRunStats = <ThrowOnError extends boolean = false>(
  options?: Options<IduPepCheckRunStatsData, ThrowOnError>,
): RequestResult<IduPepCheckRunStatsResponses, IduPepCheckRunStatsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduPepCheckRunStatsResponses,
    IduPepCheckRunStatsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/pep-check-run-stats',
    ...options,
  });

/**
 * BNDRY threshold alert history
 *
 * History of BNDRY daily-threshold emails actually sent, including the window, count, threshold and environment for each (admin dashboard only)
 */
export const iduBndryAlertHistory = <ThrowOnError extends boolean = false>(
  options?: Options<IduBndryAlertHistoryData, ThrowOnError>,
): RequestResult<IduBndryAlertHistoryResponses, IduBndryAlertHistoryErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduBndryAlertHistoryResponses,
    IduBndryAlertHistoryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/bndry-alert-history',
    ...options,
  });

/**
 * Get IDU Settings
 *
 * Get IDU settings (admin dashboard only)
 */
export const iduSettingsGet = <ThrowOnError extends boolean = false>(
  options?: Options<IduSettingsGetData, ThrowOnError>,
): RequestResult<IduSettingsGetResponses, IduSettingsGetErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduSettingsGetResponses, IduSettingsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/settings',
    ...options,
  });

/**
 * Update IDU Settings
 *
 * Update IDU settings (admin dashboard only)
 */
export const iduSettingsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduSettingsUpdateData, ThrowOnError>,
): RequestResult<IduSettingsUpdateResponses, IduSettingsUpdateErrors, ThrowOnError> =>
  (options.client ?? client).patch<
    IduSettingsUpdateResponses,
    IduSettingsUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List users
 *
 * List all users (admin dashboard only)
 */
export const iduUserList = <ThrowOnError extends boolean = false>(
  options?: Options<IduUserListData, ThrowOnError>,
): RequestResult<IduUserListResponses, IduUserListErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduUserListResponses, IduUserListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users',
    ...options,
  });

/**
 * Create user
 *
 * Create a new user and optionally associate them to venues
 */
export const iduUserCreate = <ThrowOnError extends boolean = false>(
  options: Options<IduUserCreateData, ThrowOnError>,
): RequestResult<IduUserCreateResponses, IduUserCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<IduUserCreateResponses, IduUserCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Search user by email
 *
 * Get a single user by querying with their email
 */
export const iduUserEmailSearch = <ThrowOnError extends boolean = false>(
  options: Options<IduUserEmailSearchData, ThrowOnError>,
): RequestResult<IduUserEmailSearchResponses, IduUserEmailSearchErrors, ThrowOnError> =>
  (options.client ?? client).get<
    IduUserEmailSearchResponses,
    IduUserEmailSearchErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/email',
    ...options,
  });

/**
 * Unrestricted user search
 *
 * Search for users without needing a venue. This returns users across the whole iDU database.
 */
export const iduUserSearch = <ThrowOnError extends boolean = false>(
  options?: Options<IduUserSearchData, ThrowOnError>,
): RequestResult<IduUserSearchResponses, IduUserSearchErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduUserSearchResponses, IduUserSearchErrors, ThrowOnError>({
    url: '/api/v1/idu/users/search',
    ...options,
  });

/**
 * Get user details
 *
 * Get a single user and their venue/application assignments (admin dashboard only)
 */
export const iduUserGet = <ThrowOnError extends boolean = false>(
  options: Options<IduUserGetData, ThrowOnError>,
): RequestResult<IduUserGetResponses, IduUserGetErrors, ThrowOnError> =>
  (options.client ?? client).get<IduUserGetResponses, IduUserGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}',
    ...options,
  });

/**
 * Update user
 *
 * Update user profile fields (admin dashboard only)
 */
export const iduUserUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduUserUpdateData, ThrowOnError>,
): RequestResult<IduUserUpdateResponses, IduUserUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<IduUserUpdateResponses, IduUserUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove a user from a venue
 *
 * Disassociate an existing user from an existing venue (admin dashboard only)
 */
export const iduUserRemoveFromVenue = <ThrowOnError extends boolean = false>(
  options: Options<IduUserRemoveFromVenueData, ThrowOnError>,
): RequestResult<IduUserRemoveFromVenueResponses, IduUserRemoveFromVenueErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    IduUserRemoveFromVenueResponses,
    IduUserRemoveFromVenueErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Associate a user to a venue
 *
 * Associate an existing user with an existing venue (admin dashboard only)
 */
export const iduUserAssignToVenue = <ThrowOnError extends boolean = false>(
  options: Options<IduUserAssignToVenueData, ThrowOnError>,
): RequestResult<IduUserAssignToVenueResponses, IduUserAssignToVenueErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduUserAssignToVenueResponses,
    IduUserAssignToVenueErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{targetVenueId}/users/{userId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reset or override a user password
 *
 * Override a password or trigger a password reset email (admin dashboard only)
 */
export const iduUserPasswordChange = <ThrowOnError extends boolean = false>(
  options: Options<IduUserPasswordChangeData, ThrowOnError>,
): RequestResult<IduUserPasswordChangeResponses, IduUserPasswordChangeErrors, ThrowOnError> =>
  (options.client ?? client).put<
    IduUserPasswordChangeResponses,
    IduUserPasswordChangeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}/password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reset or override a user password
 *
 * Override a password or trigger a password reset email (admin dashboard only)
 */
export const iduUserResetPassword = <ThrowOnError extends boolean = false>(
  options: Options<IduUserResetPasswordData, ThrowOnError>,
): RequestResult<IduUserResetPasswordResponses, IduUserResetPasswordErrors, ThrowOnError> =>
  (options.client ?? client).put<
    IduUserResetPasswordResponses,
    IduUserResetPasswordErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}/password/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a user's two-step sign-in
 *
 * Whether two-step sign-in is on and which kinds of method are set up; never a secret
 */
export const iduUserTwoStep = <ThrowOnError extends boolean = false>(
  options: Options<IduUserTwoStepData, ThrowOnError>,
): RequestResult<IduUserTwoStepResponses, IduUserTwoStepErrors, ThrowOnError> =>
  (options.client ?? client).get<IduUserTwoStepResponses, IduUserTwoStepErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}/two-step',
    ...options,
  });

/**
 * Turn a user's two-step sign-in on or off
 *
 * Refused with 409 while the account's access requires it. Turning it off needs a reason. Audited.
 */
export const iduUserTwoStepUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduUserTwoStepUpdateData, ThrowOnError>,
): RequestResult<IduUserTwoStepUpdateResponses, IduUserTwoStepUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    IduUserTwoStepUpdateResponses,
    IduUserTwoStepUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}/two-step',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reset a user's two-step sign-in
 *
 * Removes their methods, remembered devices, sent codes and lockout, so they set up a new method at their next sign-in. Audited with the reason, and the person is emailed.
 */
export const iduUserTwoStepReset = <ThrowOnError extends boolean = false>(
  options: Options<IduUserTwoStepResetData, ThrowOnError>,
): RequestResult<IduUserTwoStepResetResponses, IduUserTwoStepResetErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduUserTwoStepResetResponses,
    IduUserTwoStepResetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}/two-step/reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Give a user a one-time sign-in code
 *
 * Passes one sign-in's second step within 15 minutes, replacing any earlier code, and clears a lockout. Their methods and devices are unchanged, and a pass from it can't change them. Never for the admin's own account. Audited with the reason, and the person is emailed.
 */
export const iduUserTwoStepCode = <ThrowOnError extends boolean = false>(
  options: Options<IduUserTwoStepCodeData, ThrowOnError>,
): RequestResult<IduUserTwoStepCodeResponses, IduUserTwoStepCodeErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduUserTwoStepCodeResponses,
    IduUserTwoStepCodeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/users/{userId}/two-step/code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Summary
 *
 * Description
 */
export const iduUserInviteCreate = <ThrowOnError extends boolean = false>(
  options: Options<IduUserInviteCreateData, ThrowOnError>,
): RequestResult<IduUserInviteCreateResponses, IduUserInviteCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduUserInviteCreateResponses,
    IduUserInviteCreateErrors,
    ThrowOnError
  >({
    url: '/api/v1/idu/venues/{venueId}/invites',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Manually accept a pending invitation (override)
 *
 * iDU-admin-only. Activates the association without the recipient following the link. Bypasses proof of address, so the account still requires email verification before use.
 */
export const iduInviteManualAccept = <ThrowOnError extends boolean = false>(
  options: Options<IduInviteManualAcceptData, ThrowOnError>,
): RequestResult<IduInviteManualAcceptResponses, IduInviteManualAcceptErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduInviteManualAcceptResponses,
    IduInviteManualAcceptErrors,
    ThrowOnError
  >({
    url: '/api/v1/idu/venues/{venueId}/users/{userId}/invite/manual-accept',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add a user directly, skipping the invite process
 *
 * iDU-admin-only. Creates the user (if needed) and an active association with no invite. The resulting account still requires email verification before use (Q-A) — skipping the invite never exempts anyone from FR-001.
 */
export const iduInviteSkipAndAdd = <ThrowOnError extends boolean = false>(
  options: Options<IduInviteSkipAndAddData, ThrowOnError>,
): RequestResult<IduInviteSkipAndAddResponses, IduInviteSkipAndAddErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduInviteSkipAndAddResponses,
    IduInviteSkipAndAddErrors,
    ThrowOnError
  >({
    url: '/api/v1/idu/venues/{venueId}/invites/skip',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Re-send a venue invitation
 *
 * iDU-admin-only. Issues a fresh link and expiry for an existing pending invitation and sends a new email. The window comes from idu_settings, so a re-send picks up the currently configured expiry rather than the one the original invite was issued under.
 */
export const iduInviteResend = <ThrowOnError extends boolean = false>(
  options: Options<IduInviteResendData, ThrowOnError>,
): RequestResult<IduInviteResendResponses, IduInviteResendErrors, ThrowOnError> =>
  (options.client ?? client).post<IduInviteResendResponses, IduInviteResendErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{venueId}/users/{userId}/invite/resend',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Revoke a venue invitation
 *
 * iDU-admin-only. Removes a never-accepted invitation entirely, and with it the placeholder user record where that person has no authentication identity, no grant anywhere and no other pending invite (FR-008/Q-L). An accepted invitation is never reachable by this path.
 */
export const iduInviteRevoke = <ThrowOnError extends boolean = false>(
  options: Options<IduInviteRevokeData, ThrowOnError>,
): RequestResult<IduInviteRevokeResponses, IduInviteRevokeErrors, ThrowOnError> =>
  (options.client ?? client).post<IduInviteRevokeResponses, IduInviteRevokeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/venues/{venueId}/users/{userId}/invite/revoke',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List invitations
 *
 * iDU-admin-only. Lists invitations across all venues and applications, with the venue, role and application each one grants and the server-authoritative expiry. Defaults to pending invitations.
 */
export const iduInviteList = <ThrowOnError extends boolean = false>(
  options?: Options<IduInviteListData, ThrowOnError>,
): RequestResult<IduInviteListResponses, IduInviteListErrors, ThrowOnError> =>
  (options?.client ?? client).get<IduInviteListResponses, IduInviteListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/invites',
    ...options,
  });

/**
 * Invite delivery availability
 *
 * iDU-admin-only. For every application, whether an invite can be issued as a link and sent as an email in this environment, with the refusal code when it cannot. The same rules the invite and resend endpoints refuse with.
 */
export const iduInviteAvailability = <ThrowOnError extends boolean = false>(
  options?: Options<IduInviteAvailabilityData, ThrowOnError>,
): RequestResult<IduInviteAvailabilityResponses, IduInviteAvailabilityErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduInviteAvailabilityResponses,
    IduInviteAvailabilityErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/invites/availability',
    ...options,
  });

/**
 * List dashboard users
 *
 * iDU-admin-only. Lists everyone holding a grant on the iDU dashboard venue, with the role each one holds, so admin and non-admin access are distinguishable.
 */
export const iduDashboardUsersList = <ThrowOnError extends boolean = false>(
  options?: Options<IduDashboardUsersListData, ThrowOnError>,
): RequestResult<IduDashboardUsersListResponses, IduDashboardUsersListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduDashboardUsersListResponses,
    IduDashboardUsersListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/dashboard-users',
    ...options,
  });

/**
 * Grant dashboard access
 *
 * iDU-admin-only. Grants admin access to the iDU dashboard, creating the user if they do not exist. The venue is resolved server-side from the dashboard venue, never supplied by the caller — the dashboard UI runs under whichever venue the operator’s own grant sits on, which is not necessarily the dashboard venue.
 */
export const iduDashboardUserAdd = <ThrowOnError extends boolean = false>(
  options: Options<IduDashboardUserAddData, ThrowOnError>,
): RequestResult<IduDashboardUserAddResponses, IduDashboardUserAddErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduDashboardUserAddResponses,
    IduDashboardUserAddErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/dashboard-users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List in-app messages
 *
 * List all in-app messages (admin dashboard only)
 */
export const iduInAppMessageList = <ThrowOnError extends boolean = false>(
  options?: Options<IduInAppMessageListData, ThrowOnError>,
): RequestResult<IduInAppMessageListResponses, IduInAppMessageListErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    IduInAppMessageListResponses,
    IduInAppMessageListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/in-app-messages',
    ...options,
  });

/**
 * Create in-app message
 */
export const iduInAppMessageCreate = <ThrowOnError extends boolean = false>(
  options: Options<IduInAppMessageCreateData, ThrowOnError>,
): RequestResult<IduInAppMessageCreateResponses, IduInAppMessageCreateErrors, ThrowOnError> =>
  (options.client ?? client).post<
    IduInAppMessageCreateResponses,
    IduInAppMessageCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/in-app-messages',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete in-app message
 */
export const iduInAppMessageDelete = <ThrowOnError extends boolean = false>(
  options: Options<IduInAppMessageDeleteData, ThrowOnError>,
): RequestResult<IduInAppMessageDeleteResponses, IduInAppMessageDeleteErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    IduInAppMessageDeleteResponses,
    IduInAppMessageDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/in-app-messages/{id}',
    ...options,
  });

/**
 * Get in-app message
 */
export const iduInAppMessageGet = <ThrowOnError extends boolean = false>(
  options: Options<IduInAppMessageGetData, ThrowOnError>,
): RequestResult<IduInAppMessageGetResponses, IduInAppMessageGetErrors, ThrowOnError> =>
  (options.client ?? client).get<
    IduInAppMessageGetResponses,
    IduInAppMessageGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/in-app-messages/{id}',
    ...options,
  });

/**
 * Update in-app message
 */
export const iduInAppMessageUpdate = <ThrowOnError extends boolean = false>(
  options: Options<IduInAppMessageUpdateData, ThrowOnError>,
): RequestResult<IduInAppMessageUpdateResponses, IduInAppMessageUpdateErrors, ThrowOnError> =>
  (options.client ?? client).put<
    IduInAppMessageUpdateResponses,
    IduInAppMessageUpdateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/idu/in-app-messages/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List the venue managers and pending invites
 *
 * The nightlife managers and pending manager invites at the venue, for the application the x-idu-application header names.
 */
export const nightlifeManagerList = <ThrowOnError extends boolean = false>(
  options: Options<NightlifeManagerListData, ThrowOnError>,
): RequestResult<NightlifeManagerListResponses, NightlifeManagerListErrors, ThrowOnError> =>
  (options.client ?? client).get<
    NightlifeManagerListResponses,
    NightlifeManagerListErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/nightlife/venue/{venueId}/managers',
    ...options,
  });

/**
 * Invite a venue manager
 *
 * Emails a Manager invitation to the venue for the application the x-idu-application header names.
 */
export const nightlifeManagerInvite = <ThrowOnError extends boolean = false>(
  options: Options<NightlifeManagerInviteData, ThrowOnError>,
): RequestResult<NightlifeManagerInviteResponses, NightlifeManagerInviteErrors, ThrowOnError> =>
  (options.client ?? client).post<
    NightlifeManagerInviteResponses,
    NightlifeManagerInviteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/nightlife/venue/{venueId}/managers/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Resend a venue manager invite
 *
 * Re-issues and emails a pending Manager invitation at the venue.
 */
export const nightlifeManagerInviteResend = <ThrowOnError extends boolean = false>(
  options: Options<NightlifeManagerInviteResendData, ThrowOnError>,
): RequestResult<
  NightlifeManagerInviteResendResponses,
  NightlifeManagerInviteResendErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    NightlifeManagerInviteResendResponses,
    NightlifeManagerInviteResendErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/nightlife/venue/{venueId}/managers/{userId}/invite/resend',
    ...options,
  });

/**
 * Revoke a venue manager invite
 *
 * Cancels a pending Manager invitation at the venue.
 */
export const nightlifeManagerInviteRevoke = <ThrowOnError extends boolean = false>(
  options: Options<NightlifeManagerInviteRevokeData, ThrowOnError>,
): RequestResult<
  NightlifeManagerInviteRevokeResponses,
  NightlifeManagerInviteRevokeErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    NightlifeManagerInviteRevokeResponses,
    NightlifeManagerInviteRevokeErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/nightlife/venue/{venueId}/managers/{userId}/invite',
    ...options,
  });

/**
 * Remove a venue manager
 *
 * Ends an active manager's access to the venue; nightlife ends their sessions there. The record is kept.
 */
export const nightlifeManagerRemove = <ThrowOnError extends boolean = false>(
  options: Options<NightlifeManagerRemoveData, ThrowOnError>,
): RequestResult<NightlifeManagerRemoveResponses, NightlifeManagerRemoveErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    NightlifeManagerRemoveResponses,
    NightlifeManagerRemoveErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/nightlife/venue/{venueId}/managers/{userId}',
    ...options,
  });

/**
 * Grant a moved nightlife login
 *
 * Called by the nightlife API when an old iDU login moves to its own account: creates or reactivates an active Manager grant at the web-apps venue linked to the nightlife venue. 403 when the caller is another nightlife project's service account. 404 VENUE_NOT_LINKED or USER_NOT_FOUND.
 */
export const internalNightlifeGrantCreate = <ThrowOnError extends boolean = false>(
  options: Options<InternalNightlifeGrantCreateData, ThrowOnError>,
): RequestResult<
  InternalNightlifeGrantCreateResponses,
  InternalNightlifeGrantCreateErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    InternalNightlifeGrantCreateResponses,
    InternalNightlifeGrantCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/internal/nightlife/grants',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
